import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "budget-starter" }
const _hoisted_2 = { class: "starter-container" }
const _hoisted_3 = { class: "progress-sidebar" }
const _hoisted_4 = { class: "year-selector" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "year-display" }
const _hoisted_7 = { class: "year-value" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "progress-info" }
const _hoisted_10 = { class: "progress-circle" }
const _hoisted_11 = { viewBox: "0 0 100 100" }
const _hoisted_12 = { class: "progress-percent" }
const _hoisted_13 = { class: "progress-text" }
const _hoisted_14 = { class: "current" }
const _hoisted_15 = { class: "total" }
const _hoisted_16 = { class: "summary-section" }
const _hoisted_17 = { class: "summary-item revenue" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "summary-item expense" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "summary-header" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = {
  key: 0,
  class: "labor-cost-section"
}
const _hoisted_24 = { class: "labor-cost-header" }
const _hoisted_25 = { class: "labor-cost-content" }
const _hoisted_26 = { class: "labor-cost-item standard" }
const _hoisted_27 = { class: "labor-cost-value" }
const _hoisted_28 = { class: "labor-cost-value" }
const _hoisted_29 = { class: "labor-tooltip-content" }
const _hoisted_30 = { class: "tooltip-row" }
const _hoisted_31 = { class: "tooltip-value" }
const _hoisted_32 = { class: "tooltip-row" }
const _hoisted_33 = { class: "tooltip-value" }
const _hoisted_34 = { class: "tooltip-formula" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "section-nav" }
const _hoisted_38 = { class: "nav-icon revenue" }
const _hoisted_39 = { class: "nav-count" }
const _hoisted_40 = { class: "nav-icon expense" }
const _hoisted_41 = { class: "nav-count" }
const _hoisted_42 = { class: "question-main" }
const _hoisted_43 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_44 = { class: "empty-icon" }
const _hoisted_45 = { class: "top-nav" }
const _hoisted_46 = { class: "breadcrumb" }
const _hoisted_47 = { class: "step-info" }
const _hoisted_48 = { class: "step-dots" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "question-header" }
const _hoisted_51 = { class: "question-title" }
const _hoisted_52 = {
  key: 0,
  class: "hint-box"
}
const _hoisted_53 = { class: "desc-icon" }
const _hoisted_54 = { class: "desc-content" }
const _hoisted_55 = {
  key: 0,
  class: "desc-list"
}
const _hoisted_56 = { class: "desc-number" }
const _hoisted_57 = { class: "desc-text" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "input-section" }
const _hoisted_60 = {
  key: 0,
  class: "number-input-row"
}
const _hoisted_61 = { class: "field-label" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = { class: "input-suffix" }
const _hoisted_64 = {
  key: 1,
  class: "select-input-row"
}
const _hoisted_65 = ["value"]
const _hoisted_66 = {
  key: 2,
  class: "composite-grid"
}
const _hoisted_67 = { class: "field-label" }
const _hoisted_68 = { class: "select-wrapper" }
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = ["value"]
const _hoisted_71 = {
  key: 3,
  class: "multi-number-grid"
}
const _hoisted_72 = { class: "field-label" }
const _hoisted_73 = ["value", "onInput"]
const _hoisted_74 = {
  key: 0,
  class: "input-suffix"
}
const _hoisted_75 = {
  key: 4,
  class: "salary-input-section"
}
const _hoisted_76 = { class: "salary-inputs" }
const _hoisted_77 = { class: "field-label" }
const _hoisted_78 = ["value", "onInput"]
const _hoisted_79 = {
  key: 0,
  class: "input-suffix"
}
const _hoisted_80 = {
  key: 0,
  class: "insurance-preview"
}
const _hoisted_81 = { class: "insurance-header" }
const _hoisted_82 = {
  key: 0,
  class: "excluded-note"
}
const _hoisted_83 = { class: "insurance-summary" }
const _hoisted_84 = { class: "summary-row" }
const _hoisted_85 = { class: "summary-value" }
const _hoisted_86 = { class: "summary-row" }
const _hoisted_87 = { class: "summary-value" }
const _hoisted_88 = {
  key: 0,
  class: "summary-row"
}
const _hoisted_89 = { class: "summary-value" }
const _hoisted_90 = {
  key: 5,
  class: "caregiver-salary-section"
}
const _hoisted_91 = { class: "ceo-toggle-row" }
const _hoisted_92 = { class: "toggle-label" }
const _hoisted_93 = {
  key: 0,
  class: "ceo-inputs"
}
const _hoisted_94 = { class: "input-group-header" }
const _hoisted_95 = { class: "director-fields" }
const _hoisted_96 = { class: "director-field expense" }
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "director-field expense" }
const _hoisted_99 = ["value"]
const _hoisted_100 = {
  key: 0,
  class: "calc-note"
}
const _hoisted_101 = { class: "director-inputs" }
const _hoisted_102 = { class: "input-group-header" }
const _hoisted_103 = { class: "director-fields" }
const _hoisted_104 = { class: "director-field expense" }
const _hoisted_105 = ["placeholder", "value", "disabled"]
const _hoisted_106 = {
  key: 0,
  class: "field-hint"
}
const _hoisted_107 = {
  key: 1,
  class: "field-hint warning"
}
const _hoisted_108 = { class: "director-field expense" }
const _hoisted_109 = ["value"]
const _hoisted_110 = {
  key: 0,
  class: "calc-note"
}
const _hoisted_111 = {
  key: 1,
  class: "insurance-preview"
}
const _hoisted_112 = { class: "insurance-header" }
const _hoisted_113 = { class: "insurance-summary" }
const _hoisted_114 = { class: "summary-row" }
const _hoisted_115 = { class: "summary-value" }
const _hoisted_116 = { class: "summary-row" }
const _hoisted_117 = { class: "summary-value" }
const _hoisted_118 = { class: "summary-row" }
const _hoisted_119 = { class: "summary-value" }
const _hoisted_120 = { class: "summary-row" }
const _hoisted_121 = { class: "summary-value" }
const _hoisted_122 = { class: "summary-row total" }
const _hoisted_123 = { class: "summary-value highlight" }
const _hoisted_124 = {
  key: 6,
  class: "director-salary-section"
}
const _hoisted_125 = { class: "ceo-toggle-row" }
const _hoisted_126 = { class: "toggle-label" }
const _hoisted_127 = {
  key: 0,
  class: "ceo-inputs"
}
const _hoisted_128 = { class: "input-group-header" }
const _hoisted_129 = { class: "director-fields" }
const _hoisted_130 = { class: "director-field expense" }
const _hoisted_131 = ["value"]
const _hoisted_132 = { class: "director-field expense" }
const _hoisted_133 = ["value"]
const _hoisted_134 = { class: "director-inputs" }
const _hoisted_135 = { class: "input-group-header" }
const _hoisted_136 = { class: "director-fields" }
const _hoisted_137 = { class: "director-field expense" }
const _hoisted_138 = ["value"]
const _hoisted_139 = { class: "director-field expense" }
const _hoisted_140 = ["value"]
const _hoisted_141 = {
  key: 1,
  class: "insurance-preview"
}
const _hoisted_142 = { class: "insurance-header" }
const _hoisted_143 = { class: "insurance-summary" }
const _hoisted_144 = { class: "summary-row" }
const _hoisted_145 = { class: "summary-value" }
const _hoisted_146 = { class: "summary-row" }
const _hoisted_147 = { class: "summary-value" }
const _hoisted_148 = { class: "summary-row" }
const _hoisted_149 = { class: "summary-value" }
const _hoisted_150 = { class: "summary-row" }
const _hoisted_151 = { class: "summary-value" }
const _hoisted_152 = { class: "summary-row total" }
const _hoisted_153 = { class: "summary-value highlight" }
const _hoisted_154 = {
  key: 7,
  class: "social-worker-salary-section"
}
const _hoisted_155 = { class: "ceo-toggle-row" }
const _hoisted_156 = { class: "toggle-label" }
const _hoisted_157 = {
  key: 0,
  class: "ceo-inputs"
}
const _hoisted_158 = { class: "input-group-header" }
const _hoisted_159 = { class: "director-fields" }
const _hoisted_160 = { class: "director-field expense" }
const _hoisted_161 = ["value"]
const _hoisted_162 = { class: "director-field expense" }
const _hoisted_163 = ["value"]
const _hoisted_164 = { class: "director-inputs" }
const _hoisted_165 = { class: "input-group-header" }
const _hoisted_166 = { class: "director-fields" }
const _hoisted_167 = { class: "director-field expense" }
const _hoisted_168 = ["value"]
const _hoisted_169 = { class: "director-field expense" }
const _hoisted_170 = ["value"]
const _hoisted_171 = {
  key: 1,
  class: "bonus-preview"
}
const _hoisted_172 = { class: "bonus-header" }
const _hoisted_173 = { class: "bonus-formula" }
const _hoisted_174 = { class: "formula-row" }
const _hoisted_175 = { class: "formula-value" }
const _hoisted_176 = { class: "formula-note" }
const _hoisted_177 = { class: "formula-row" }
const _hoisted_178 = { class: "formula-value highlight" }
const _hoisted_179 = { class: "formula-row annual" }
const _hoisted_180 = { class: "formula-value" }
const _hoisted_181 = {
  key: 2,
  class: "insurance-preview"
}
const _hoisted_182 = { class: "insurance-header" }
const _hoisted_183 = { class: "insurance-summary" }
const _hoisted_184 = { class: "summary-row" }
const _hoisted_185 = { class: "summary-value" }
const _hoisted_186 = { class: "summary-row" }
const _hoisted_187 = { class: "summary-value" }
const _hoisted_188 = { class: "summary-row" }
const _hoisted_189 = { class: "summary-value" }
const _hoisted_190 = { class: "summary-row" }
const _hoisted_191 = { class: "summary-value" }
const _hoisted_192 = { class: "summary-row total" }
const _hoisted_193 = { class: "summary-value highlight" }
const _hoisted_194 = {
  key: 8,
  class: "toggle-group"
}
const _hoisted_195 = { class: "toggle-icon" }
const _hoisted_196 = { class: "toggle-icon" }
const _hoisted_197 = { class: "preview-header" }
const _hoisted_198 = { class: "preview-content" }
const _hoisted_199 = { class: "preview-item" }
const _hoisted_200 = { class: "preview-value" }
const _hoisted_201 = { class: "preview-arrow" }
const _hoisted_202 = { class: "preview-item highlight" }
const _hoisted_203 = { class: "preview-value" }
const _hoisted_204 = { class: "action-buttons" }
const _hoisted_205 = ["disabled"]
const _hoisted_206 = ["disabled"]
const _hoisted_207 = ["disabled"]
const _hoisted_208 = {
  key: 0,
  class: "balance-alert"
}

import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';

interface SugaData {
  suga_idx: number;
  suga_biz_gubun: string;
  suga_year: string;
  suga_rank: string;
  suga_money: number;
  suga_bonin: number;
  suga_wdate: string;
}

// 세금/보험 요율 인터페이스
interface TaxData {
  tr_idx?: number;
  tr_year?: string;
  tr_time_pay?: number;   // 최저시급
  tr_yeon?: number;       // 국민연금 요율
  tr_gun?: number;        // 건강보험 요율
  tr_go?: number;         // 고용보험 요율
  tr_jang?: number;       // 장기요양보험 요율 (건강보험 기준)
  tr_sil?: number;        // 실업급여 요율
  tr_san?: number;        // 산재보험 요율
  tr_labor_cost_rate?: number; // 인건비 지출 비율
}

// 소득세 테이블 인터페이스
interface SojiData {
  income1: number;
  income2: number;
  depe_1: number;
}

// Props & Emits
interface QuestionOption {
  value: string | number;
  label: string;
}

interface QuestionField {
  key: string;
  label: string;
  options?: QuestionOption[];
  type?: 'select' | 'number' | 'toggle';
  scode?: string;        // hb_scode
  suffix?: string;
  funding?: string;      // hb_funding
}

// 보험 적용 설정 인터페이스
interface InsuranceConfig {
  nationalPension?: boolean;      // 국민연금
  healthInsurance?: boolean;      // 건강보험
  longTermCare?: boolean;         // 장기요양보험
  employmentInsurance?: boolean;  // 고용보험
  unemployment?: boolean;         // 실업급여 (사업자)
  industrialAccident?: boolean;   // 산재보험
  retirement?: boolean;           // 퇴직금
}

interface Question {
  code: string;
  section: '세입' | '세출';
  sequence: number;
  question: string;
  shortLabel?: string;
  inputType: 'number' | 'select' | 'composite' | 'toggle' | 'multi-number' | 'salary' | 'caregiver-salary' | 'social-worker-salary' | 'director-salary';
  frequency: 'monthly' | 'once' | 'annual' | 'count' | 'reference';
  hint?: string;
  description?: string;
  placeholder?: string;
  suffix?: string;
  options?: QuestionOption[];
  fields?: QuestionField[];
  defaultValue?: string | number;
  disabled?: boolean;
  scode?: string;                  // hb_scode (salary 타입용)
  funding?: string;                // hb_funding
  insuranceConfig?: InsuranceConfig; // 보험 적용 설정 (salary 타입용)
}

interface BudgetData {
  year: string;
  answers: Record<string, string | number>;
  calculations: {
    totalRevenue: number;
    totalExpense: number;
    balance: number;
    bonusRevenue: number;
    items: BudgetItem[];
  };
  budgetEntries?: HhBudgetEntry[]; // hh_budget 테이블에 저장할 데이터
}

interface BudgetItem {
  code: string;
  section: string;
  label: string;
  monthly: number;
  annual: number;
}

// hh_budget 테이블 저장용 인터페이스
interface HhBudgetEntry {
  m_sisul_code: string;     // 시설코드
  hb_year: string;          // 연도
  hb_gubun: 'IN' | 'OUT';   // 구분 (세입/세출)
  hb_scode: string;         // 계정코드 (fc_scode)
  hb_bud_class: string;     // 예산분류
  hb_memo: string;          // 메모/항목명
  hb_price: string;         // 단가
  hb_person: string;        // 명(회)
  hb_month: string;         // 개월
  hb_amount: string;        // 금액
  hb_funding: string;       // 재원구분
  pay_rel_group?: string;   // 급여-보험-퇴직금 연결 그룹 (임시 식별자, 백엔드에서 hb_pay_rel로 변환)
  pay_rel_type?: 'salary' | 'insurance' | 'retirement'; // 급여/보험/퇴직금 타입
}

// 상태

export default /*@__PURE__*/_defineComponent({
  __name: 'PgmBudgetStarter',
  props: {
    year: {},
    sugaList: {},
    sugaYear: {},
    sugaIsFallback: { type: Boolean },
    sugaError: {},
    sugaLoading: { type: Boolean },
    taxData: {},
    sojiData: {},
    taxLoading: { type: Boolean },
    taxError: {},
    budgetClass: {}
  },
  emits: ["complete", "cancel", "year-change"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

// 수가 인터페이스 (props용)
const props = __props;

const emit = __emit;

// 연도 범위
const currentSystemYear = new Date().getFullYear();
const minYear = currentSystemYear - 2;
const maxYear = currentSystemYear + 1;

// 연도 변경 함수
const changeYear = (delta: number) => {
  const newYear = parseInt(searchParams.value.lebYear) + delta;
  if (newYear >= minYear && newYear <= maxYear) {
    searchParams.value.lebYear = newYear.toString();
    emit('year-change', searchParams.value.lebYear);
  }
};

// 추경차수 관련 computed
const budgetClassLabel = computed(() => {
  const budClass = props.budgetClass || '';
  if (!budClass || budClass === '0') return '본예산';
  return `${budClass}차 추경`;
});

const budgetClassStyle = computed(() => {
  const budClass = props.budgetClass || '';
  if (!budClass || budClass === '0') return 'primary';
  return 'warning';
});

const budgetClassIcon = computed(() => {
  const budClass = props.budgetClass || '';
  if (!budClass || budClass === '0') return 'mdi-file-document-outline';
  return 'mdi-file-document-edit-outline';
});

// 인터페이스
const searchParams = ref({
  lebYear: props.year || store.state.lebYear || new Date().getFullYear().toString(),
});

const currentStep = ref(1);
const answers = ref<Record<string, string | number>>({});
const compositeAnswers = ref<Record<string, string | number | boolean>>({});
const currentAnswer = ref<string>('');
const inputFocused = ref(false);

// hh_budget 테이블 저장용 데이터
const budgetEntries = ref<HhBudgetEntry[]>([]);

// 세입 질문
const revenueQuestions = ref<Question[]>([
  {
    code: 'revenue_target_clients',
    section: '세입',
    sequence: 1,
    question: '예산년도 목표 수급자수는 몇 명입니까?',
    shortLabel: '목표 수급자수',
    inputType: 'number',
    frequency: 'count',
    hint: '결산년도 대비 30% 이상 권장',
    description: '① 예산은 계획이므로 되도록 많이 책정하는 것이 추경의 횟수를 줄일 수 있다. ② 수급자별 평균 서비스 제공시간은 180분 20회로 한정한다. ③ 가족요양은 별도로 추가하지 않는다. ④ 위의 기준은 예산년도에 발생되는 수급자수, 감경적용여부, 서비스 제공시간 등을 특정할 수 없기 때문이므로, 수정을 원하시면 절차가 마무리 되면, 추후 직접 수정하시면 됩니다.',
    placeholder: '수급자 수',
    suffix: '명',
  },
  {
    code: 'revenue_loans_transfer',
    section: '세입',
    sequence: 2,
    question: '금융기관 차입금 / 기타차입금 / 기타전입금이 있습니까?',
    shortLabel: '차입금/전입금',
    inputType: 'multi-number',
    frequency: 'once',
    description: '① 1년 이상 적립하여 상환하여야 할 상황인 경우에는 \'금융기관 차입\' 또는 \'기타 차입\'을 하는 것이 좋다. 차입을 하는 경우에는 지자체에 차입금 관련 보고서를 제출하여 승인을 받은 이후에 예산에 반영이 가능합니다. ② 하지만 1년 이내 상환이 가능한 금액은 차입보다는 전입을 하고, 기타전출금으로 처리하는 것을 권장합니다. 전입의 경우는 지자체의 승인이 불필요합니다.',
    fields: [
      { key: 'bankLoan', label: '금융기관 차입금', type: 'number', scode: '711', suffix: '원', funding: '04' },
      { key: 'otherLoan', label: '기타차입금', type: 'number', scode: '712', suffix: '원', funding: '04' },
      { key: 'otherTransfer', label: '기타전입금', type: 'number', scode: '813', suffix: '원', funding: '04' },
    ],
  },
  {
    code: 'revenue_carryover_misc',
    section: '세입',
    sequence: 3,
    question: '전년도이월금 / 기타예금이자수입 / 기타잡수입이 있습니까?',
    shortLabel: '이월금/이자/잡수입',
    inputType: 'multi-number',
    frequency: 'once',
    description: '① 전년도이월금: 결산연도 말에 예상되는 잔고를 산입 ② 기타예금이자수입: 예금이자는 1,000원 ~ 10,000원으로 산입 ③ 기타잡수입: 정부의 인건비 지원금 또는 각종 잡수입 산입',
    fields: [
      { key: 'carryover', label: '전년도이월금', type: 'number', scode: '911', suffix: '원', funding: '04' },
      { key: 'interest', label: '기타예금이자수입', type: 'number', scode: '1012', suffix: '원', funding: '04' },
      { key: 'misc', label: '기타잡수입', type: 'number', scode: '1014', suffix: '원', funding: '04' },
    ],
  },
]);

// 세출 질문
const expenseQuestions = ref<Question[]>([
  {
    code: 'expense_director_salary',
    section: '세출',
    sequence: 1,
    question: '센터장의 월 임금은 얼마입니까?',
    shortLabel: '센터장 급여',
    inputType: 'director-salary', // 대표자/비대표자 구분 가능한 새 타입
    frequency: 'monthly',
    description: '① 대표자는 고용보험, 산재보험, 퇴직금이 제외됩니다. ② 대표자가 아닌 센터장은 모든 사회보험과 퇴직금이 적용됩니다.',
    fields: [
      { key: 'hasCeo', label: '대표자 센터장 여부', type: 'toggle' },
      { key: 'ceoSalary', label: '대표자 센터장 월 급여', type: 'number', suffix: '원' },
      { key: 'ceoCount', label: '대표자 센터장 수', type: 'number', suffix: '명' },
      { key: 'directorCount', label: '일반 센터장 수', type: 'number', suffix: '명' },
      { key: 'directorSalary', label: '일반 센터장 월 급여', type: 'number', suffix: '원' },
    ],
    scode: '1112',  // 급여(간접비)
    funding: '',
  },
  {
    code: 'expense_social_worker_salary',
    section: '세출',
    sequence: 2,
    question: '사회복지사 인원 및 월 급여는 얼마입니까?',
    shortLabel: '사회복지사 급여',
    inputType: 'social-worker-salary',
    frequency: 'monthly',
    description: '① 대표자가 사회복지사로 근무하는 경우 대표자 스위치를 켜세요. ② 사회복지사 인원에 따라 가산금이 자동으로 세입에 반영됩니다.',
    fields: [
      { key: 'hasCeo', label: '대표자 사회복지사 여부', type: 'toggle' },
      { key: 'ceoSalary', label: '대표자 사회복지사 월 급여', type: 'number', suffix: '원' },
      { key: 'ceoCount', label: '대표자 사회복지사 수', type: 'number', suffix: '명' },
      { key: 'workerCount', label: '일반 사회복지사 수', type: 'number', suffix: '명' },
      { key: 'workerSalary', label: '일반 사회복지사 월 급여', type: 'number', suffix: '원' },
    ],
    scode: '1111',  // 급여(직접비)
    funding: '06',
  },
  {
    code: 'expense_caregiver_hourly',
    section: '세출',
    sequence: 3,
    question: '예산년도 요양보호사 시간당 인건비는 얼마입니까?',
    shortLabel: '요양보호사 급여',
    inputType: 'caregiver-salary',
    frequency: 'monthly',
    hint: '2025년도 전국 평균 12,800원',
    description: '① 대표자가 요양보호사로 근무하는 경우 대표자 스위치를 켜세요. ② 요양보호사 수의 기본값은 목표 수급자 수와 동일합니다.',
    fields: [
      { key: 'hasCeo', label: '대표자 요양보호사 여부', type: 'toggle' },
      { key: 'ceoHourlyWage', label: '대표자 요양보호사 시급', type: 'number', suffix: '원' },
      { key: 'ceoCount', label: '대표자 요양보호사 수', type: 'number', suffix: '명' },
      { key: 'caregiverCount', label: '일반 요양보호사 수', type: 'number', suffix: '명' },
      { key: 'caregiverHourlyWage', label: '일반 요양보호사 시급', type: 'number', suffix: '원' },
    ],
    scode: '1111',  // 급여(직접비)
    funding: '06',
  },
  {
    code: 'expense_operation_rent',
    section: '세출',
    sequence: 4,
    question: '기관운영비 / 사무실 임차료가 있습니까?',
    shortLabel: '운영비/임차료',
    inputType: 'multi-number',
    frequency: 'monthly',
    description: '① 기관운영비: 기관운영 및 유관기관과의 업무협의를 위한 경비 ② 임차료: 사무실 임차료',
    fields: [
      { key: 'operation', label: '기관운영비', type: 'number', scode: '121', suffix: '원', funding: '' },
      { key: 'rent', label: '사무실 임차료', type: 'number', scode: '135', suffix: '원', funding: '' },
    ],
  },
  {
    code: 'expense_allowance_meeting',
    section: '세출',
    sequence: 5,
    question: '직책보조비 / 회의비가 있습니까?',
    shortLabel: '직책보조비/회의비',
    inputType: 'multi-number',
    frequency: 'monthly',
    description: '① 직책보조비: 영수증 없는 지출. 인건비지출비율이 높을 때 인건비 조절을 위해 활용. 과도한 사용은 탈세혐의 우려 ② 회의비: 월간 회의 및 다과비에 사용되는 경비',
    fields: [
      { key: 'allowance', label: '직책보조비', type: 'number', scode: '122', suffix: '원', funding: '' },
      { key: 'meeting', label: '회의비', type: 'number', scode: '123', suffix: '원', funding: '' },
    ],
  },
  {
    code: 'expense_loan_repayment',
    section: '세출',
    sequence: 6,
    question: '차입금에 대한 상환금이 있습니까?',
    shortLabel: '원금상환금',
    inputType: 'multi-number',
    frequency: 'monthly',
    description: '① 월 상환 계획 금액을 입력합니다.',
    fields: [
      { key: 'repayment', label: '원금상환금', type: 'number', scode: '611', suffix: '원', funding: '' },
    ],
  },
]);

// Computed
const allQuestions = computed<Question[]>(() => {
  return [...revenueQuestions.value, ...expenseQuestions.value];
});

const totalQuestions = computed(() => allQuestions.value.length);

const answeredCount = computed(() => {
  return Object.keys(answers.value).filter(k => answers.value[k] !== '').length;
});

const progressPercent = computed(() => {
  if (totalQuestions.value === 0) return 0;
  return (answeredCount.value / totalQuestions.value) * 100;
});

const progressOffset = computed(() => {
  const circumference = 2 * Math.PI * 45;
  return circumference - (progressPercent.value / 100) * circumference;
});

const currentQuestion = computed<Question>(() => {
  return allQuestions.value[currentStep.value - 1] || revenueQuestions.value[0];
});

const currentSection = computed(() => {
  return currentQuestion.value?.section === '세입' ? 'revenue' : 'expense';
});

const currentSectionQuestions = computed(() => {
  return currentSection.value === 'revenue' ? revenueQuestions.value : expenseQuestions.value;
});

const revenueAnsweredCount = computed(() => {
  return revenueQuestions.value.filter(q => answers.value[q.code]).length;
});

const expenseAnsweredCount = computed(() => {
  return expenseQuestions.value.filter(q => answers.value[q.code]).length;
});

const isRevenueCompleted = computed(() => {
  return revenueAnsweredCount.value === revenueQuestions.value.length;
});

const isExpenseCompleted = computed(() => {
  return expenseAnsweredCount.value === expenseQuestions.value.length;
});

// 180분 수가 데이터 (기준 수가) - props에서 가져옴
const suga180 = computed<SugaData | null>(() => {
  return props.sugaList?.find(s => s.suga_rank === '180분') || null;
});

// 수가 데이터 유효 여부
const hasSugaData = computed(() => {
  return (props.sugaList?.length || 0) > 0 && suga180.value !== null;
});

const isCurrentAnswerValid = computed(() => {
  const question = currentQuestion.value;
  
  if (!question) return false;
  
  if (question.inputType === 'composite') {
    const fields = question.fields || [];
    return fields.every(f => compositeAnswers.value[f.key]);
  }
  
  // multi-number는 선택적 입력 (0 또는 미입력 허용)
  if (question.inputType === 'multi-number') {
    return true;
  }
  
  // salary는 급여가 입력되어야 함 (인원수는 기본값 1)
  if (question.inputType === 'salary') {
    const salary = Number(compositeAnswers.value['salary']) || 0;
    return salary > 0;
  }
  
  // director-salary: 대표자 또는 일반 센터장 중 하나라도 입력되어야 함
  if (question.inputType === 'director-salary') {
    const hasCeo = compositeAnswers.value['hasCeo'];
    const ceoSalary = Number(compositeAnswers.value['ceoSalary']) || 0;
    const ceoCount = Number(compositeAnswers.value['ceoCount']) || 0;
    const directorCount = Number(compositeAnswers.value['directorCount']) || 0;
    const directorSalary = Number(compositeAnswers.value['directorSalary']) || 0;
    
    // 대표자가 있으면 대표자 급여 필수
    if (hasCeo && (ceoSalary <= 0 || ceoCount <= 0)) {
      return false;
    }
    // 일반 센터장이 있으면 일반 센터장 급여 필수
    if (directorCount > 0 && directorSalary <= 0) {
      return false;
    }
    // 대표자 또는 일반 센터장 중 하나는 있어야 함
    return (hasCeo && ceoSalary > 0) || (directorCount > 0 && directorSalary > 0);
  }
  
  // caregiver-salary: 대표자 또는 일반 요양보호사 중 하나라도 입력되어야 함
  if (question.inputType === 'caregiver-salary') {
    const hasCeo = compositeAnswers.value['hasCeo'];
    const ceoHourlyWage = Number(compositeAnswers.value['ceoHourlyWage']) || 0;
    const ceoCount = Number(compositeAnswers.value['ceoCount']) || 0;
    const caregiverCount = Number(compositeAnswers.value['caregiverCount']) || targetClientsCount.value;
    const caregiverHourlyWage = Number(compositeAnswers.value['caregiverHourlyWage']) || 0;
    
    // 대표자가 있으면 대표자 시급 필수
    if (hasCeo && (ceoHourlyWage <= 0 || ceoCount <= 0)) {
      return false;
    }
    // 일반 요양보호사가 있으면 시급 필수
    if (caregiverCount > 0 && caregiverHourlyWage <= 0) {
      return false;
    }
    // 대표자 또는 일반 요양보호사 중 하나는 있어야 함
    return (hasCeo && ceoHourlyWage > 0) || (caregiverCount > 0 && caregiverHourlyWage > 0);
  }
  
  // social-worker-salary: 대표자 또는 일반 사회복지사 중 하나라도 입력되어야 함
  if (question.inputType === 'social-worker-salary') {
    const hasCeo = compositeAnswers.value['hasCeo'];
    const ceoSalary = Number(compositeAnswers.value['ceoSalary']) || 0;
    const ceoCount = Number(compositeAnswers.value['ceoCount']) || 0;
    const workerCount = Number(compositeAnswers.value['workerCount']) || 0;
    const workerSalary = Number(compositeAnswers.value['workerSalary']) || 0;
    
    // 대표자가 있으면 대표자 급여 필수
    if (hasCeo && (ceoSalary <= 0 || ceoCount <= 0)) {
      return false;
    }
    // 일반 사회복지사가 있으면 급여 필수
    if (workerCount > 0 && workerSalary <= 0) {
      return false;
    }
    // 대표자 또는 일반 사회복지사 중 하나는 있어야 함
    return (hasCeo && ceoSalary > 0) || (workerCount > 0 && workerSalary > 0);
  }
  
  if (question.inputType === 'toggle') {
    return currentAnswer.value === 'yes' || currentAnswer.value === 'no';
  }
  
  if (question.defaultValue !== undefined && !currentAnswer.value) {
    return true;
  }
  
  return currentAnswer.value !== '';
});

// 입력 기준 표시 (월/연)
const getPeriodLabel = (frequency: string, section: string): string => {
  if (frequency === 'count' || frequency === 'reference') {
    return ''; // 인원수나 참고용은 표시 안함
  }
  if (frequency === 'monthly') {
    return '/ 월';
  }
  if (frequency === 'once' || frequency === 'annual') {
    return '/ 연';
  }
  return '';
};

// 현재 질문의 기준 표시
const currentPeriodLabel = computed(() => {
  const q = currentQuestion.value;
  if (!q) return '';
  return getPeriodLabel(q.frequency, currentSection.value);
});

// multi-number 필드의 기준 표시 (세입은 연, 세출은 월)
const getMultiNumberPeriodLabel = computed(() => {
  const q = currentQuestion.value;
  if (!q) return '';
  // 세입 multi-number는 1회성(연), 세출 multi-number는 월 단위
  if (q.section === '세입' && q.frequency === 'once') {
    return '/ 연';
  }
  if (q.section === '세출') {
    return '/ 월';
  }
  return getPeriodLabel(q.frequency, currentSection.value);
});

const isAllAnswered = computed(() => {
  return allQuestions.value.every((q, idx) => {
    // 기본값이 있는 질문은 답변 필수 아님
    if (q.defaultValue !== undefined) {
      return true;
    }
    
    // multi-number는 선택적 입력 (0 또는 미입력 허용)
    if (q.inputType === 'multi-number') {
      return true;
    }
    
    // 현재 질문이면 currentAnswer도 확인
    if (idx === currentStep.value - 1) {
      return currentAnswer.value !== '' || (answers.value[q.code] !== undefined && answers.value[q.code] !== '');
    }
    
    return answers.value[q.code] !== undefined && answers.value[q.code] !== '';
  });
});

const calculatedPreview = computed(() => {
  const question = currentQuestion.value;
  if (!question) return null;
  
  const value = parseNumber(currentAnswer.value);
  
  if (!value && question.defaultValue === undefined) return null;
  
  // reference(참고용)는 미리보기 표시 안함
  if (question.frequency === 'reference' || question.frequency === 'count') {
    return null;
  }
  
  const numValue = value || (question.defaultValue as number) || 0;
  
  let monthly = 0;
  let annual = 0;
  
  switch (question.frequency) {
    case 'monthly':
      monthly = numValue;
      annual = numValue * 12;
      break;
    case 'once':
    case 'annual':
      monthly = Math.round(numValue / 12);
      annual = numValue;
      break;
  }
  
  // 사회복지사 급여: 기본 2명 기준
  if (question.code === 'expense_social_worker_salary') {
    const count = 2; // 기본 2명 (Q&A에서 제외됨)
    monthly = numValue * count;
    annual = monthly * 12;
  }
  
  return { monthly, annual };
});

// 사회복지사 인원에 따른 가산점수 계산 (함수)
const getSocialWorkerBonusPoint = (count: number): number => {
  if (count <= 0) return 0;
  if (count === 1) return 1.8;
  if (count === 2) return 3.2;
  // 2명 초과부터 1.2점씩 추가
  return 3.2 + (count - 2) * 1.2;
};

// 가산급여 계산 (세입에 포함) - 사회복지사 인원 기준
const bonusRevenue = computed(() => {
  const targetClients = parseNumber(String(answers.value['revenue_target_clients'])) || 0;
  
  // 사회복지사 인원수 가져오기 (social-worker-salary 질문에서)
  // 현재 질문이 사회복지사 급여면 compositeAnswers 사용, 아니면 저장된 answers 사용
  let socialWorkerCount = 0;
  
  if (currentQuestion.value?.code === 'expense_social_worker_salary') {
    // 현재 입력 중인 값 사용
    const hasCeo = compositeAnswers.value['hasCeo'];
    const ceoCount = hasCeo ? (Number(compositeAnswers.value['ceoCount']) || 0) : 0;
    const workerCount = Number(compositeAnswers.value['workerCount']) || 0;
    socialWorkerCount = ceoCount + workerCount;
  } else {
    // 저장된 값 사용
    const swAnswer = answers.value['expense_social_worker_salary'];
    if (swAnswer && typeof swAnswer === 'string') {
      try {
        const parsed = JSON.parse(swAnswer);
        const hasCeo = parsed['hasCeo'];
        const ceoCount = hasCeo ? (Number(parsed['ceoCount']) || 0) : 0;
        const workerCount = Number(parsed['workerCount']) || 0;
        socialWorkerCount = ceoCount + workerCount;
      } catch { /* ignore */ }
    }
  }
  
  if (targetClients === 0 || socialWorkerCount === 0) return 0;
  
  // 4등급 180분 기준 수가 찾기 (props에서 가져옴)
  const suga = props.sugaList?.find(s => s.suga_rank === '180분');
  if (!suga) return 0;
  
  const sugaMoney = Number(suga.suga_money) || 0;
  
  // 수급자별 청구금액 = 180분 수가 × 20회
  const clientBillingAmount = sugaMoney * 20;
  
  // 가산점수 계산
  const bonusScore = getSocialWorkerBonusPoint(socialWorkerCount);
  
  // 가산식 = (수급자별 청구금액 × 85% ÷ 청구인원수) × 가산점수 × 방문요양 가산유형(1.8)
  const monthlyBonus = Math.round((clientBillingAmount * 0.85 / targetClients) * bonusScore * 1.8 * targetClients);
  
  return monthlyBonus * 12;
});

const totalRevenue = computed(() => {
  let total = 0;
  
  // 180분 수가 데이터
  const suga = props.sugaList?.find(s => s.suga_rank === '180분');
  const sugaMoney = suga ? Number(suga.suga_money) : 0;
  const sugaBonin = suga ? Number(suga.suga_bonin) : 0;
  const sugaGubyo = sugaMoney - sugaBonin; // 급여비용 (공단부담)
  
  revenueQuestions.value.forEach(q => {
    // 목표 수급자수 → 본인부담금수입 + 장기요양급여수입
    if (q.code === 'revenue_target_clients') {
      const value = parseNumber(String(answers.value[q.code])) || 0;
      const targetClients = value;
      if (targetClients > 0 && suga) {
        const boninAmount = sugaBonin * 20 * targetClients * 12;
        const gubyoAmount = sugaGubyo * 20 * targetClients * 12;
        total += boninAmount + gubyoAmount;
      }
    }
    // multi-number (차입금/전입금)
    else if (q.inputType === 'multi-number' && q.fields) {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          q.fields.forEach(field => {
            const fieldValue = Number(parsed[field.key]) || 0;
            total += fieldValue; // 1회성 금액
          });
        } catch { /* ignore */ }
      }
    }
    else if (q.frequency === 'monthly') {
      const value = parseNumber(String(answers.value[q.code])) || 0;
      total += value * 12;
    } else if (q.frequency === 'once') {
      const value = parseNumber(String(answers.value[q.code])) || 0;
      total += value;
    }
  });
  
  // 가산급여 추가
  total += bonusRevenue.value;
  
  return total;
});

const totalExpense = computed(() => {
  let total = 0;
  
  expenseQuestions.value.forEach(q => {
    // reference(참고용)는 합계에서 제외
    if (q.frequency === 'reference') {
      return;
    }
    
    // multi-number 타입: 각 필드 값 합산
    if (q.inputType === 'multi-number' && q.fields) {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          q.fields.forEach(field => {
            const fieldValue = Number(parsed[field.key]) || 0;
            total += fieldValue * 12; // 월 금액 × 12개월
          });
        } catch { /* ignore */ }
      }
      return;
    }
    
    // salary 타입: 급여 + 사회보험부담금(기관 기준) 합산
    if (q.inputType === 'salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const salary = Number(parsed['salary']) || 0;
          const count = Number(parsed['count']) || 1;
          const totalSalary = salary * count;
          
          // 연간 급여
          const annualSalary = totalSalary * 12;
          
          // 사회보험부담금 계산 - 기관 기준 (실업급여, 산재보험, 퇴직금 포함)
          const config = q.insuranceConfig || {};
          const nationalPension = config.nationalPension ? Math.round(totalSalary * (props.taxData?.tr_yeon || 0)) : 0;
          const healthInsurance = config.healthInsurance ? Math.round(totalSalary * (props.taxData?.tr_gun || 0)) : 0;
          const longTermCare = config.longTermCare ? Math.round(healthInsurance * (props.taxData?.tr_jang || 0)) : 0;
          const employmentInsurance = config.employmentInsurance ? Math.round(totalSalary * (props.taxData?.tr_go || 0)) : 0;
          const unemployment = config.unemployment ? Math.round(totalSalary * (props.taxData?.tr_sil || 0)) : 0;
          const industrialAccident = config.industrialAccident ? Math.round(totalSalary * (props.taxData?.tr_san || 0)) : 0;
          const retirement = config.retirement ? Math.round(totalSalary / 12) : 0;
          
          const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
          const annualInsurance = monthlyInsurance * 12;
          
          total += annualSalary + annualInsurance;
        } catch { /* ignore */ }
      }
      return;
    }
    
    // director-salary 타입: 대표자/일반 센터장 구분
    if (q.inputType === 'director-salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const hasCeo = parsed['hasCeo'];
          const ceoSalary = Number(parsed['ceoSalary']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          const directorCount = Number(parsed['directorCount']) || 0;
          const directorSalary = Number(parsed['directorSalary']) || 0;
          
          // 대표자 계산 (고용/산재/퇴직금 제외)
          if (hasCeo && ceoSalary > 0 && ceoCount > 0) {
            const totalCeoSalary = ceoSalary * ceoCount;
            const nationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
            total += (totalCeoSalary + monthlyInsurance) * 12;
          }
          
          // 일반 센터장 계산 (모든 보험 + 퇴직금)
          if (directorCount > 0 && directorSalary > 0) {
            const totalDirectorSalary = directorSalary * directorCount;
            const nationalPension = Math.round(totalDirectorSalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(totalDirectorSalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const employmentInsurance = Math.round(totalDirectorSalary * (props.taxData?.tr_go || 0));
            const unemployment = Math.round(totalDirectorSalary * (props.taxData?.tr_sil || 0));
            const industrialAccident = Math.round(totalDirectorSalary * (props.taxData?.tr_san || 0));
            const retirement = Math.round(totalDirectorSalary / 12);
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
            total += (totalDirectorSalary + monthlyInsurance) * 12;
          }
        } catch { /* ignore */ }
      }
      return;
    }
    
    // caregiver-salary 타입: 대표자/일반 구분
    if (q.inputType === 'caregiver-salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const hasCeo = parsed['hasCeo'];
          const ceoHourlyWage = Number(parsed['ceoHourlyWage']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          const caregiverCount = Number(parsed['caregiverCount']) || targetClientsCount.value;
          const caregiverHourlyWage = Number(parsed['caregiverHourlyWage']) || 0;
          
          // 대표자 계산 (고용/산재/퇴직금 제외)
          if (hasCeo && ceoHourlyWage > 0 && ceoCount > 0) {
            const monthlySalary = ceoHourlyWage * 60;
            const totalCeoSalary = monthlySalary * ceoCount;
            const nationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
            total += (totalCeoSalary + monthlyInsurance) * 12;
          }
          
          // 일반 요양보호사 계산 (모든 보험 + 퇴직금)
          if (caregiverCount > 0 && caregiverHourlyWage > 0) {
            const monthlySalary = caregiverHourlyWage * 60;
            const totalCaregiverSalary = monthlySalary * caregiverCount;
            const nationalPension = Math.round(totalCaregiverSalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(totalCaregiverSalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const employmentInsurance = Math.round(totalCaregiverSalary * (props.taxData?.tr_go || 0));
            const unemployment = Math.round(totalCaregiverSalary * (props.taxData?.tr_sil || 0));
            const industrialAccident = Math.round(totalCaregiverSalary * (props.taxData?.tr_san || 0));
            const retirement = Math.round(totalCaregiverSalary / 12);
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
            total += (totalCaregiverSalary + monthlyInsurance) * 12;
          }
        } catch { /* ignore */ }
      }
      return;
    }
    
    // social-worker-salary 타입: 대표자/일반 구분
    if (q.inputType === 'social-worker-salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const hasCeo = parsed['hasCeo'];
          const ceoSalary = Number(parsed['ceoSalary']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          const workerCount = Number(parsed['workerCount']) || 0;
          const workerSalary = Number(parsed['workerSalary']) || 0;
          
          // 대표자 계산 (고용/산재/퇴직금 제외)
          if (hasCeo && ceoSalary > 0 && ceoCount > 0) {
            const totalCeoSalary = ceoSalary * ceoCount;
            const nationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
            total += (totalCeoSalary + monthlyInsurance) * 12;
          }
          
          // 일반 사회복지사 계산 (모든 보험 + 퇴직금)
          if (workerCount > 0 && workerSalary > 0) {
            const totalWorkerSalary = workerSalary * workerCount;
            const nationalPension = Math.round(totalWorkerSalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(totalWorkerSalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const employmentInsurance = Math.round(totalWorkerSalary * (props.taxData?.tr_go || 0));
            const unemployment = Math.round(totalWorkerSalary * (props.taxData?.tr_sil || 0));
            const industrialAccident = Math.round(totalWorkerSalary * (props.taxData?.tr_san || 0));
            const retirement = Math.round(totalWorkerSalary / 12);
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
            total += (totalWorkerSalary + monthlyInsurance) * 12;
          }
        } catch { /* ignore */ }
      }
      return;
    }
    
    const value = parseNumber(String(answers.value[q.code])) || 0;
    
    // 사회복지사 급여: 기본 2명 × 월급 × 12 (legacy - 제거 예정)
    if (q.code === 'expense_social_worker_salary_legacy') {
      const count = 2; // 기본 2명 (Q&A에서 제외됨)
      total += value * count * 12;
    } else if (q.frequency === 'monthly') {
      total += value * 12;
    } else if (q.frequency === 'once') {
      total += value;
    }
    // count는 합계에서 제외 (인원수)
  });
  
  return total;
});

const balance = computed(() => {
  return totalRevenue.value - totalExpense.value;
});

// 기준 인건비 지출 비율 (hh_tax_rate 테이블의 tr_labor_cost_rate)
const standardLaborCostRate = computed(() => {
  return props.taxData?.tr_labor_cost_rate || 60; // 기본값 60%
});

// 인건비 총액 계산 (scode 기준: 1111 + 1151 + 1141, 시설장 제외)
// 1111: 급여(직접비), 1151: 사회보험부담금(직접비), 1141: 퇴직금(직접비)
const totalLaborCost = computed(() => {
  let total = 0;
  
  expenseQuestions.value.forEach(q => {
    // caregiver-salary, social-worker-salary 타입만 (시설장은 간접비 1112, 1152, 1142 사용하므로 제외)
    if (q.inputType === 'caregiver-salary' || q.inputType === 'social-worker-salary') {
      // 현재 질문이면 compositeAnswers 사용, 아니면 저장된 answers 사용
      let parsed: Record<string, string | number | boolean> = {};
      
      if (currentQuestion.value?.code === q.code) {
        parsed = { ...compositeAnswers.value };
      } else {
        const savedAnswer = answers.value[q.code];
        if (savedAnswer && typeof savedAnswer === 'string') {
          try {
            parsed = JSON.parse(savedAnswer);
          } catch { /* ignore */ }
        }
      }
      
      if (q.inputType === 'caregiver-salary') {
        // 대표자 요양보호사 (고용/산재/퇴직금 제외)
        const hasCeo = parsed['hasCeo'];
        if (hasCeo) {
          const ceoHourlyWage = Number(parsed['ceoHourlyWage']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          if (ceoHourlyWage > 0 && ceoCount > 0) {
            const monthlySalary = ceoHourlyWage * 60 * ceoCount;
            const annualSalary = monthlySalary * 12;
            // 대표자: 국민연금, 건강보험, 장기요양만
            const nationalPension = Math.round(monthlySalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(monthlySalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
            total += annualSalary + (monthlyInsurance * 12);
          }
        }
        
        // 일반 요양보호사 (모든 보험 + 퇴직금)
        const caregiverHourlyWage = Number(parsed['caregiverHourlyWage']) || 0;
        const caregiverCount = Number(parsed['caregiverCount']) || targetClientsCount.value;
        if (caregiverHourlyWage > 0 && caregiverCount > 0) {
          const monthlySalary = caregiverHourlyWage * 60 * caregiverCount;
          const annualSalary = monthlySalary * 12;
          const nationalPension = Math.round(monthlySalary * (props.taxData?.tr_yeon || 0));
          const healthInsurance = Math.round(monthlySalary * (props.taxData?.tr_gun || 0));
          const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
          const employmentInsurance = Math.round(monthlySalary * (props.taxData?.tr_go || 0));
          const unemployment = Math.round(monthlySalary * (props.taxData?.tr_sil || 0));
          const industrialAccident = Math.round(monthlySalary * (props.taxData?.tr_san || 0));
          const retirement = Math.round(monthlySalary / 12);
          const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
          total += annualSalary + (monthlyInsurance * 12);
        }
      } else if (q.inputType === 'social-worker-salary') {
        // 대표자 사회복지사 (고용/산재/퇴직금 제외)
        const hasCeo = parsed['hasCeo'];
        if (hasCeo) {
          const ceoSalary = Number(parsed['ceoSalary']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          if (ceoSalary > 0 && ceoCount > 0) {
            const monthlySalary = ceoSalary * ceoCount;
            const annualSalary = monthlySalary * 12;
            // 대표자: 국민연금, 건강보험, 장기요양만
            const nationalPension = Math.round(monthlySalary * (props.taxData?.tr_yeon || 0));
            const healthInsurance = Math.round(monthlySalary * (props.taxData?.tr_gun || 0));
            const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
            total += annualSalary + (monthlyInsurance * 12);
          }
        }
        
        // 일반 사회복지사 (모든 보험 + 퇴직금)
        const workerSalary = Number(parsed['workerSalary']) || 0;
        const workerCount = Number(parsed['workerCount']) || 0;
        if (workerSalary > 0 && workerCount > 0) {
          const monthlySalary = workerSalary * workerCount;
          const annualSalary = monthlySalary * 12;
          const nationalPension = Math.round(monthlySalary * (props.taxData?.tr_yeon || 0));
          const healthInsurance = Math.round(monthlySalary * (props.taxData?.tr_gun || 0));
          const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
          const employmentInsurance = Math.round(monthlySalary * (props.taxData?.tr_go || 0));
          const unemployment = Math.round(monthlySalary * (props.taxData?.tr_sil || 0));
          const industrialAccident = Math.round(monthlySalary * (props.taxData?.tr_san || 0));
          const retirement = Math.round(monthlySalary / 12);
          const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
          total += annualSalary + (monthlyInsurance * 12);
        }
      }
    }
  });
  
  return total;
});

// 인건비 비율 계산용 수입 (scode 기준: 112 + 611 + 613)
const laborCostBaseRevenue = computed(() => {
  // 180분 수가 데이터
  const suga = props.sugaList?.find(s => s.suga_rank === '180분');
  if (!suga) return 0;
  
  const sugaMoney = Number(suga.suga_money) || 0;
  const sugaBonin = Number(suga.suga_bonin) || 0;
  const sugaGubyo = sugaMoney - sugaBonin; // 급여비용 (공단부담)
  
  // 목표 수급자수 가져오기 (현재 입력 중이면 compositeAnswers, 아니면 answers)
  let targetClients = 0;
  if (currentQuestion.value?.code === 'revenue_target_clients') {
    targetClients = parseNumber(String(currentAnswer.value)) || 0;
  } else {
    targetClients = parseNumber(String(answers.value['revenue_target_clients'])) || 0;
  }
  
  if (targetClients <= 0) return 0;
  
  // scode 112: 본인부담금수입
  const scode112 = sugaBonin * 20 * targetClients * 12;
  // scode 611: 장기요양급여수입
  const scode611 = sugaGubyo * 20 * targetClients * 12;
  // scode 613: 가산금수입 (사회복지사)
  const scode613 = bonusRevenue.value;
  
  return scode112 + scode611 + scode613;
});

// 현재 인건비 지출 비율 = 지출(요양보호사,사회복지사 급여,보험,퇴직금) / 수입(장기요양급여수입, 본인부담금수입, 가산금) × 100
const currentLaborCostRate = computed(() => {
  if (laborCostBaseRevenue.value === 0) return 0;
  return (totalLaborCost.value / laborCostBaseRevenue.value) * 100;
});

// 인건비 비율 기준 미달 여부 (기준비율보다 현재비율이 낮으면 미달)
const isLaborCostBelowStandard = computed(() => {
  return currentLaborCostRate.value < standardLaborCostRate.value;
});

// 인건비 비율 산출근거 툴팁 텍스트
const laborCostTooltip = computed(() => {
  const laborCost = totalLaborCost.value;
  const baseRevenue = laborCostBaseRevenue.value;
  const rate = currentLaborCostRate.value;
  
  return `산출근거:\n` +
    `인건비 지출 = ${formatMoney(laborCost)}원\n` +
    `(요양보호사·사회복지사 급여+보험+퇴직금)\n\n` +
    `수입 = ${formatMoney(baseRevenue)}원\n` +
    `(장기요양급여+본인부담금+가산금)\n\n` +
    `비율 = ${formatMoney(laborCost)} ÷ ${formatMoney(baseRevenue)} × 100\n` +
    `     = ${rate.toFixed(1)}%`;
});

// salary 타입의 사회보험부담금 미리보기 계산
const salaryInsurancePreview = computed(() => {
  const question = currentQuestion.value;
  
  if (!question || question.inputType !== 'salary') {
    return null;
  }
  
  const salary = Number(compositeAnswers.value['salary']) || 0;
  const count = Number(compositeAnswers.value['count']) || 1;
  
  if (salary <= 0) {
    return null;
  }
  
  const config = question.insuranceConfig || {};
  const totalSalary = salary * count; // 총 급여 (월급 × 인원수)
  
  // 사업자 부담 계산
  const nationalPension = config.nationalPension ? Math.round(totalSalary * (props.taxData?.tr_yeon || 0)) : 0;
  const healthInsurance = config.healthInsurance ? Math.round(totalSalary * (props.taxData?.tr_gun || 0)) : 0;
  const longTermCare = config.longTermCare ? Math.round(healthInsurance * (props.taxData?.tr_jang || 0)) : 0;
  const employmentInsurance = config.employmentInsurance ? Math.round(totalSalary * (props.taxData?.tr_go || 0)) : 0;
  const unemployment = config.unemployment ? Math.round(totalSalary * (props.taxData?.tr_sil || 0)) : 0;
  const industrialAccident = config.industrialAccident ? Math.round(totalSalary * (props.taxData?.tr_san || 0)) : 0;
  const retirement = config.retirement ? Math.round(totalSalary / 12) : 0;
  
  const total = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
  const annualSalary = totalSalary * 12; // 연간 급여
  const annualInsurance = total * 12;    // 연간 보험료
  const annualTotal = annualSalary + annualInsurance; // 연간 총 비용
  
  return {
    nationalPension,
    healthInsurance,
    longTermCare,
    employmentInsurance,
    unemployment,
    industrialAccident,
    retirement,
    total,
    annualSalary,
    annualInsurance,
    annualTotal
  };
});

// director-salary 타입의 사회보험부담금 미리보기 계산 (대표자/일반 센터장 구분)
const directorInsurancePreview = computed(() => {
  const question = currentQuestion.value;
  
  if (!question || question.inputType !== 'director-salary') {
    return null;
  }
  
  const hasCeo = compositeAnswers.value['hasCeo'];
  const ceoSalary = Number(compositeAnswers.value['ceoSalary']) || 0;
  const ceoCount = Number(compositeAnswers.value['ceoCount']) || 0;
  const directorCount = Number(compositeAnswers.value['directorCount']) || 0;
  const directorSalary = Number(compositeAnswers.value['directorSalary']) || 0;
  
  let result: {
    ceo?: { annualSalary: number; annualInsurance: number };
    director?: { annualSalary: number; annualInsurance: number };
    totalAnnual: number;
  } = { totalAnnual: 0 };
  
  // 대표자 계산 (고용/산재/퇴직금 제외)
  if (hasCeo && ceoSalary > 0 && ceoCount > 0) {
    const totalCeoSalary = ceoSalary * ceoCount;
    const nationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
    const healthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
    const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
    // 대표자: 고용보험, 산재보험, 퇴직금 제외
    const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
    
    result.ceo = {
      annualSalary: totalCeoSalary * 12,
      annualInsurance: monthlyInsurance * 12
    };
    result.totalAnnual += result.ceo.annualSalary + result.ceo.annualInsurance;
  }
  
  // 일반 센터장 계산 (모든 보험 + 퇴직금)
  if (directorCount > 0 && directorSalary > 0) {
    const totalDirectorSalary = directorSalary * directorCount;
    const nationalPension = Math.round(totalDirectorSalary * (props.taxData?.tr_yeon || 0));
    const healthInsurance = Math.round(totalDirectorSalary * (props.taxData?.tr_gun || 0));
    const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
    const employmentInsurance = Math.round(totalDirectorSalary * (props.taxData?.tr_go || 0));
    const unemployment = Math.round(totalDirectorSalary * (props.taxData?.tr_sil || 0));
    const industrialAccident = Math.round(totalDirectorSalary * (props.taxData?.tr_san || 0));
    const retirement = Math.round(totalDirectorSalary / 12);
    const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
    
    result.director = {
      annualSalary: totalDirectorSalary * 12,
      annualInsurance: monthlyInsurance * 12
    };
    result.totalAnnual += result.director.annualSalary + result.director.annualInsurance;
  }
  
  if (result.totalAnnual === 0) {
    return null;
  }
  
  return result;
});

// 목표 수급자수 가져오기 (Q1에서 입력한 값)
const targetClientsCount = computed(() => {
  const answer = answers.value['revenue_target_clients'];
  if (answer) {
    return parseNumber(String(answer)) || 0;
  }
  return 0;
});

// 요양보호사 시급 기반 월급 계산 미리보기
const caregiverSalaryPreview = computed(() => {
  const question = currentQuestion.value;
  
  if (!question || question.inputType !== 'caregiver-salary') {
    return null;
  }
  
  const hourlyWage = Number(compositeAnswers.value['hourlyWage']) || 0;
  const count = targetClientsCount.value; // 요양보호사 수 = 수급자 수 (자동)
  
  if (hourlyWage <= 0 || count <= 0) {
    return null;
  }
  
  // 월급 = 시급 × 60시간 (180분 × 20회 = 3600분 = 60시간)
  const monthlySalary = hourlyWage * 60;
  const totalMonthlySalary = monthlySalary * count;
  
  return {
    hourlyWage,
    count,
    monthlySalary,
    totalMonthlySalary
  };
});

// 요양보호사 사회보험부담금 미리보기 계산
// 요양보호사 사회보험부담금 미리보기 계산 (대표자/일반 구분)
const caregiverInsurancePreview = computed(() => {
  const question = currentQuestion.value;
  
  if (!question || question.inputType !== 'caregiver-salary') {
    return null;
  }
  
  const hasCeo = compositeAnswers.value['hasCeo'];
  const ceoHourlyWage = Number(compositeAnswers.value['ceoHourlyWage']) || 0;
  const ceoCount = Number(compositeAnswers.value['ceoCount']) || 0;
  const caregiverCount = Number(compositeAnswers.value['caregiverCount']) || targetClientsCount.value;
  const caregiverHourlyWage = Number(compositeAnswers.value['caregiverHourlyWage']) || 0;
  
  let result: {
    ceo?: { annualSalary: number; annualInsurance: number };
    caregiver?: { annualSalary: number; annualInsurance: number };
    totalAnnual: number;
  } = { totalAnnual: 0 };
  
  // 대표자 계산 (고용/산재/퇴직금 제외)
  if (hasCeo && ceoHourlyWage > 0 && ceoCount > 0) {
    const monthlySalary = ceoHourlyWage * 60;
    const totalCeoSalary = monthlySalary * ceoCount;
    const nationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
    const healthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
    const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
    const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
    
    result.ceo = {
      annualSalary: totalCeoSalary * 12,
      annualInsurance: monthlyInsurance * 12
    };
    result.totalAnnual += result.ceo.annualSalary + result.ceo.annualInsurance;
  }
  
  // 일반 요양보호사 계산 (모든 보험 + 퇴직금)
  if (caregiverCount > 0 && caregiverHourlyWage > 0) {
    const monthlySalary = caregiverHourlyWage * 60;
    const totalCaregiverSalary = monthlySalary * caregiverCount;
    const nationalPension = Math.round(totalCaregiverSalary * (props.taxData?.tr_yeon || 0));
    const healthInsurance = Math.round(totalCaregiverSalary * (props.taxData?.tr_gun || 0));
    const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
    const employmentInsurance = Math.round(totalCaregiverSalary * (props.taxData?.tr_go || 0));
    const unemployment = Math.round(totalCaregiverSalary * (props.taxData?.tr_sil || 0));
    const industrialAccident = Math.round(totalCaregiverSalary * (props.taxData?.tr_san || 0));
    const retirement = Math.round(totalCaregiverSalary / 12);
    const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
    
    result.caregiver = {
      annualSalary: totalCaregiverSalary * 12,
      annualInsurance: monthlyInsurance * 12
    };
    result.totalAnnual += result.caregiver.annualSalary + result.caregiver.annualInsurance;
  }
  
  if (result.totalAnnual === 0) {
    return null;
  }
  
  return result;
});

// 사회복지사 가산금 미리보기 계산 (세입)
const socialWorkerBonusPreview = computed(() => {
  const question = currentQuestion.value;
  
  if (!question || question.inputType !== 'social-worker-salary') {
    return null;
  }
  
  // 전체 사회복지사 수 = 대표자 수 + 일반 사회복지사 수
  const hasCeo = compositeAnswers.value['hasCeo'];
  const ceoCount = hasCeo ? (Number(compositeAnswers.value['ceoCount']) || 0) : 0;
  const workerCount = Number(compositeAnswers.value['workerCount']) || 0;
  const totalCount = ceoCount + workerCount;
  
  if (totalCount <= 0) {
    return null;
  }
  
  // 180분 수가 데이터 가져오기
  const suga = props.sugaList?.find((s: SugaData) => s.suga_rank === '180분');
  if (!suga) {
    return null;
  }
  
  const sugaMoney = Number(suga.suga_money) || 0;
  const targetClients = targetClientsCount.value || 0;
  
  if (targetClients <= 0) {
    return null;
  }
  
  // 수급자별 청구금액 = 180분 수가 × 20회
  const clientBillingAmount = sugaMoney * 20;
  
  // 가산점수
  const bonusPoint = getSocialWorkerBonusPoint(totalCount);
  
  // 가산금 = (수급자별 청구금액 × 85% ÷ 청구인원수) × 가산점수 × 1.8
  const monthlyBonus = Math.round((clientBillingAmount * 0.85 / targetClients) * bonusPoint * 1.8 * targetClients);
  const annualBonus = monthlyBonus * 12;
  
  return {
    count: totalCount,
    bonusPoint,
    clientBillingAmount,
    monthlyBonus,
    annualBonus
  };
});

// 사회복지사 사회보험부담금 미리보기 계산 (대표자/일반 구분)
const socialWorkerInsurancePreview = computed(() => {
  const question = currentQuestion.value;
  
  if (!question || question.inputType !== 'social-worker-salary') {
    return null;
  }
  
  const hasCeo = compositeAnswers.value['hasCeo'];
  const ceoSalary = Number(compositeAnswers.value['ceoSalary']) || 0;
  const ceoCount = Number(compositeAnswers.value['ceoCount']) || 0;
  const workerCount = Number(compositeAnswers.value['workerCount']) || 0;
  const workerSalary = Number(compositeAnswers.value['workerSalary']) || 0;
  
  let result: {
    ceo?: { annualSalary: number; annualInsurance: number };
    worker?: { annualSalary: number; annualInsurance: number };
    totalAnnual: number;
  } = { totalAnnual: 0 };
  
  // 대표자 계산 (고용/산재/퇴직금 제외)
  if (hasCeo && ceoSalary > 0 && ceoCount > 0) {
    const totalCeoSalary = ceoSalary * ceoCount;
    const nationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
    const healthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
    const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
    const monthlyInsurance = nationalPension + healthInsurance + longTermCare;
    
    result.ceo = {
      annualSalary: totalCeoSalary * 12,
      annualInsurance: monthlyInsurance * 12
    };
    result.totalAnnual += result.ceo.annualSalary + result.ceo.annualInsurance;
  }
  
  // 일반 사회복지사 계산 (모든 보험 + 퇴직금)
  if (workerCount > 0 && workerSalary > 0) {
    const totalWorkerSalary = workerSalary * workerCount;
    const nationalPension = Math.round(totalWorkerSalary * (props.taxData?.tr_yeon || 0));
    const healthInsurance = Math.round(totalWorkerSalary * (props.taxData?.tr_gun || 0));
    const longTermCare = Math.round(healthInsurance * (props.taxData?.tr_jang || 0));
    const employmentInsurance = Math.round(totalWorkerSalary * (props.taxData?.tr_go || 0));
    const unemployment = Math.round(totalWorkerSalary * (props.taxData?.tr_sil || 0));
    const industrialAccident = Math.round(totalWorkerSalary * (props.taxData?.tr_san || 0));
    const retirement = Math.round(totalWorkerSalary / 12);
    const monthlyInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement;
    
    result.worker = {
      annualSalary: totalWorkerSalary * 12,
      annualInsurance: monthlyInsurance * 12
    };
    result.totalAnnual += result.worker.annualSalary + result.worker.annualInsurance;
  }
  
  if (result.totalAnnual === 0) {
    return null;
  }
  
  return result;
});

// ============================================
// 세출 계산을 위한 유틸리티 함수들
// ============================================

// 소득세 계산 함수
const calculateIncomeTax = (taxableIncome: number): number => {
  if (!props.sojiData || props.sojiData.length === 0) {
    return 0;
  }
  
  for (let i = 0; i < props.sojiData.length; i++) {
    const obj = props.sojiData[i];
    const minIncome = obj.income1 * 1000;
    const maxIncome = obj.income2 * 1000;
    
    if (taxableIncome >= minIncome && taxableIncome < maxIncome) {
      return Math.round(obj.depe_1);
    }
  }
  
  return 0;
};

// 근로자 4대보험 공제 계산 (급여 기준)
const calculateEmployeeDeductions = (salary: number) => {
  if (!props.taxData || !props.taxData.tr_time_pay) {
    return {
      nationalPension: 0,      // 국민연금
      healthInsurance: 0,      // 건강보험
      longTermCare: 0,         // 장기요양보험
      employmentInsurance: 0,  // 고용보험
      incomeTax: 0,            // 소득세
      localTax: 0,             // 지방세
      total: 0
    };
  }
  
  const nationalPension = Math.round(salary * (props.taxData.tr_yeon || 0));
  const healthInsurance = Math.round(salary * (props.taxData.tr_gun || 0));
  const longTermCare = Math.round(healthInsurance * (props.taxData.tr_jang || 0));
  const employmentInsurance = Math.round(salary * (props.taxData.tr_go || 0));
  const incomeTax = calculateIncomeTax(salary);
  const localTax = Math.round(incomeTax * 0.1);
  
  return {
    nationalPension,
    healthInsurance,
    longTermCare,
    employmentInsurance,
    incomeTax,
    localTax,
    total: nationalPension + healthInsurance + longTermCare + employmentInsurance + incomeTax + localTax
  };
};

// 사업자 부담 4대보험 계산 (급여 기준)
const calculateEmployerDeductions = (salary: number) => {
  if (!props.taxData || !props.taxData.tr_time_pay) {
    return {
      nationalPension: 0,      // 국민연금
      healthInsurance: 0,      // 건강보험
      longTermCare: 0,         // 장기요양보험
      employmentInsurance: 0,  // 고용보험
      unemployment: 0,         // 실업급여
      industrialAccident: 0,   // 산재보험
      retirement: 0,           // 퇴직금
      total: 0
    };
  }
  
  const nationalPension = Math.round(salary * (props.taxData.tr_yeon || 0));
  const healthInsurance = Math.round(salary * (props.taxData.tr_gun || 0));
  const longTermCare = Math.round(healthInsurance * (props.taxData.tr_jang || 0));
  const employmentInsurance = Math.round(salary * (props.taxData.tr_go || 0));
  const unemployment = Math.round(salary * (props.taxData.tr_sil || 0));
  const industrialAccident = Math.round(salary * (props.taxData.tr_san || 0));
  const retirement = Math.round(salary / 12); // 퇴직금 = 월급 / 12
  
  return {
    nationalPension,
    healthInsurance,
    longTermCare,
    employmentInsurance,
    unemployment,
    industrialAccident,
    retirement,
    total: nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident + retirement
  };
};

// 연간 사회보험부담금 계산 (사업자 부담분, 12개월)
const calculateAnnualEmployerInsurance = (monthlySalary: number): number => {
  const deductions = calculateEmployerDeductions(monthlySalary);
  // 퇴직금 제외한 보험료 합계 × 12개월
  const monthlyInsurance = deductions.nationalPension + 
                          deductions.healthInsurance + 
                          deductions.longTermCare + 
                          deductions.employmentInsurance + 
                          deductions.unemployment + 
                          deductions.industrialAccident;
  return monthlyInsurance * 12;
};

// 연간 퇴직금 계산 (12개월)
const calculateAnnualRetirement = (monthlySalary: number): number => {
  // 퇴직금 = 월급 / 12 × 12개월 = 월급
  return monthlySalary;
};

// 최저시급 가져오기
const minimumWage = computed(() => {
  return props.taxData?.tr_time_pay || 0;
});

// 세금/보험 데이터 유효 여부
const hasTaxData = computed(() => {
  return props.taxData && props.taxData.tr_time_pay && props.taxData.tr_time_pay > 0;
});

// 설명 파싱 (번호가 있으면 리스트로 변환)
const parsedDescription = computed(() => {
  const desc = currentQuestion.value?.description || '';
  
  // ①②③ 또는 1. 2. 3. 형태의 번호 패턴 감지
  const circledNumberPattern = /[①②③④⑤⑥⑦⑧⑨⑩]/g;
  const numberedPattern = /(\d+)\.\s/g;
  
  const hasCircledNumbers = circledNumberPattern.test(desc);
  const hasNumberedList = numberedPattern.test(desc);
  
  if (hasCircledNumbers) {
    // ① ② ③ 형식 파싱
    const items: { number: string; text: string }[] = [];
    const parts = desc.split(/([①②③④⑤⑥⑦⑧⑨⑩])/);
    
    for (let i = 1; i < parts.length; i += 2) {
      const number = parts[i];
      const text = parts[i + 1]?.trim() || '';
      if (text) {
        items.push({ number, text });
      }
    }
    
    return { isList: items.length > 0, items };
  }
  
  if (hasNumberedList) {
    // 1. 2. 3. 형식 파싱
    const items: { number: string; text: string }[] = [];
    const regex = /(\d+)\.\s([^0-9]+?)(?=\d+\.|$)/g;
    let match;
    
    while ((match = regex.exec(desc)) !== null) {
      items.push({ 
        number: match[1] + '.', 
        text: match[2].trim() 
      });
    }
    
    return { isList: items.length > 0, items };
  }
  
  return { isList: false, items: [] };
});

// Methods
const parseNumber = (value: string): number => {
  if (!value) return 0;
  return Number(value.replace(/[^0-9.-]/g, '')) || 0;
};

const formatMoney = (amount: number): string => {
  return new Intl.NumberFormat('ko-KR').format(amount);
};

const handleNumberInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value.replace(/[^0-9]/g, '');
  currentAnswer.value = value ? Number(value).toLocaleString() : '';
};

// multi-number 입력 값 포맷팅
const formatMultiNumberValue = (key: string): string => {
  const value = compositeAnswers.value[key];
  if (!value) return '';
  return Number(value).toLocaleString();
};

// multi-number 입력 핸들러
const handleMultiNumberInput = (event: Event, key: string) => {
  const target = event.target as HTMLInputElement;
  const value = target.value.replace(/[^0-9]/g, '');
  compositeAnswers.value[key] = value ? Number(value) : '';
};

const handleEnterKey = () => {
  if (isCurrentAnswerValid.value) {
    // 현재 답변 먼저 저장
    saveCurrentAnswer();
    
    if (currentStep.value < totalQuestions.value) {
      nextQuestion();
    } else {
      // 마지막 질문이면 바로 제출 (saveCurrentAnswer 후이므로 isAllAnswered 체크 불필요)
      submitBudget();
    }
  }
};

const saveCurrentAnswer = () => {
  const question = currentQuestion.value;
  if (!question) return;
  
  if (question.inputType === 'composite' || question.inputType === 'multi-number' || question.inputType === 'salary' || question.inputType === 'caregiver-salary' || question.inputType === 'social-worker-salary' || question.inputType === 'director-salary') {
    answers.value[question.code] = JSON.stringify(compositeAnswers.value);
  } else {
    answers.value[question.code] = currentAnswer.value || question.defaultValue || '';
  }
};

const loadCurrentAnswer = () => {
  const question = currentQuestion.value;
  if (!question) return;
  
  if (question.inputType === 'composite' || question.inputType === 'multi-number' || question.inputType === 'salary' || question.inputType === 'caregiver-salary' || question.inputType === 'social-worker-salary' || question.inputType === 'director-salary') {
    const saved = answers.value[question.code];
    if (saved && typeof saved === 'string') {
      try {
        const parsed = JSON.parse(saved);
        compositeAnswers.value = { ...parsed };
      } catch {
        compositeAnswers.value = {};
      }
    } else {
      compositeAnswers.value = {};
      // caregiver-salary의 경우 기본값 설정
      if (question.inputType === 'caregiver-salary') {
        compositeAnswers.value['hasCeo'] = false;
        compositeAnswers.value['ceoCount'] = 1;
        compositeAnswers.value['caregiverCount'] = targetClientsCount.value; // 수급자 수 기본값
      }
      // social-worker-salary의 경우 기본값 설정
      if (question.inputType === 'social-worker-salary') {
        compositeAnswers.value['hasCeo'] = false;
        compositeAnswers.value['ceoCount'] = 1;
        compositeAnswers.value['workerCount'] = 0;
      }
      // director-salary의 경우 대표자 수 기본값 1명 설정
      if (question.inputType === 'director-salary') {
        compositeAnswers.value['hasCeo'] = false;
        compositeAnswers.value['ceoCount'] = 1;
        compositeAnswers.value['directorCount'] = 0;
      }
      // salary 타입 중 센터장 급여의 경우 센터장 수 기본값 1명 설정 (legacy)
      if (question.inputType === 'salary' && question.code === 'expense_director_salary') {
        compositeAnswers.value['count'] = 1;
      }
    }
    currentAnswer.value = '';
  } else {
    currentAnswer.value = String(answers.value[question.code] || question.defaultValue || '');
  }
};

// 첫 번째 입력 필드에 포커스
const focusFirstInput = () => {
  // transition 애니메이션 완료 후 포커스 (약간의 딜레이 필요)
  setTimeout(() => {
    nextTick(() => {
      const questionCard = document.querySelector('.question-card');
      if (questionCard) {
        // .main-input 또는 .main-select 클래스를 가진 첫 번째 활성화된 요소 찾기
        // (v-switch 내부의 input 제외)
        const firstInput = questionCard.querySelector('.main-input:not([disabled]), .main-select:not([disabled])') as HTMLInputElement | HTMLSelectElement | null;
        if (firstInput) {
          firstInput.focus();
        }
      }
    });
  }, 150); // transition 시간 고려
};

const prevQuestion = () => {
  if (currentStep.value > 1) {
    saveCurrentAnswer();
    currentStep.value--;
    loadCurrentAnswer();
    // transition 완료 후 첫 번째 입력 필드에 포커스
    focusFirstInput();
  }
};

const nextQuestion = () => {
  if (currentStep.value < totalQuestions.value) {
    saveCurrentAnswer();
    currentStep.value++;
    loadCurrentAnswer();
    // transition 완료 후 첫 번째 입력 필드에 포커스
    focusFirstInput();
  }
};

const goToStep = (step: number) => {
  saveCurrentAnswer();
  currentStep.value = step;
  loadCurrentAnswer();
};

const goToQuestion = (code: string) => {
  const index = allQuestions.value.findIndex(q => q.code === code);
  if (index >= 0) {
    goToStep(index + 1);
  }
};

const goToSection = (section: 'revenue' | 'expense') => {
  const questions = section === 'revenue' ? revenueQuestions.value : expenseQuestions.value;
  const firstQuestion = questions[0];
  if (firstQuestion) {
    goToQuestion(firstQuestion.code);
  }
};

// props의 수가 데이터로 질문 옵션 업데이트 (필요시)
const updateSugaOptions = () => {
  const serviceQuestion = revenueQuestions.value.find(q => q.code === 'revenue_service_standard');
  if (serviceQuestion && serviceQuestion.fields && props.sugaList) {
    const timeField = serviceQuestion.fields.find(f => f.key === 'serviceTime');
    if (timeField) {
      timeField.options = props.sugaList.map((suga: SugaData) => ({
        value: suga.suga_rank,
        label: `${suga.suga_rank}분 (${formatMoney(suga.suga_money)}원)`
      }));
    }
  }
};

const submitBudget = () => {
  saveCurrentAnswer();
  
  const budgetItems: BudgetItem[] = [];
  const generatedEntries: HhBudgetEntry[] = [];
  
  const sisulCode = store.state.user?.m_sisul_code || '';
  const year = searchParams.value.lebYear;
  
  // 180분 수가 데이터
  const suga = props.sugaList?.find(s => s.suga_rank === '180분');
  const sugaMoney = suga ? Number(suga.suga_money) : 0;
  const sugaBonin = suga ? Number(suga.suga_bonin) : 0;
  const sugaGubyo = sugaMoney - sugaBonin; // 급여비용 (공단부담)
  
  // 세입 항목 처리
  revenueQuestions.value.forEach(q => {
    const value = parseNumber(String(answers.value[q.code])) || 0;
    let monthly = 0;
    let annual = 0;
    
    // 목표 수급자수 → 본인부담금수입(112) + 장기요양급여수입(611) 두 개 생성
    if (q.code === 'revenue_target_clients') {
      const targetClients = value;
      if (targetClients > 0 && suga) {
        // 1. 본인부담금수입 (hb_scode: 112)
        const boninPrice = sugaBonin * 20; // 180분수가 본인부담금 × 20회
        const boninAmount = boninPrice * targetClients * 12;
        
        generatedEntries.push({
          m_sisul_code: sisulCode,
          hb_year: year,
          hb_gubun: 'IN',
          hb_scode: '112',
          hb_bud_class: '',
          hb_memo: '180분수가 X 20',
          hb_price: String(boninPrice),
          hb_person: String(targetClients),
          hb_month: '12',
          hb_amount: String(boninAmount),
          hb_funding: '06', // 이용료
        });
        
        budgetItems.push({
          code: 'revenue_bonin_112',
          section: '세입',
          label: '본인부담금수입',
          monthly: Math.round(boninAmount / 12),
          annual: boninAmount
        });
        
        // 2. 장기요양급여수입 (hb_scode: 611)
        const gubyoPrice = sugaGubyo * 20; // (수가 - 본인부담) × 20회
        const gubyoAmount = gubyoPrice * targetClients * 12;
        
        generatedEntries.push({
          m_sisul_code: sisulCode,
          hb_year: year,
          hb_gubun: 'IN',
          hb_scode: '611',
          hb_bud_class: '',
          hb_memo: '180분수가 X 20',
          hb_price: String(gubyoPrice),
          hb_person: String(targetClients),
          hb_month: '12',
          hb_amount: String(gubyoAmount),
          hb_funding: '06', // 이용료
        });
        
        budgetItems.push({
          code: 'revenue_gubyo_611',
          section: '세입',
          label: '장기요양급여수입',
          monthly: Math.round(gubyoAmount / 12),
          annual: gubyoAmount
        });
        
        // 전체 합계용
        monthly = Math.round((boninAmount + gubyoAmount) / 12);
        annual = boninAmount + gubyoAmount;
      }
    }
    // multi-number: 각 필드별로 별도 hh_budget 엔트리 생성
    else if (q.inputType === 'multi-number' && q.fields) {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          q.fields.forEach(field => {
            const fieldValue = Number(parsed[field.key]) || 0;
            if (fieldValue > 0 && field.scode) {
              // hb_price = 입력값, hb_person = 1, hb_month = 1, hb_amount = price * 1 * 1
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'IN',
                hb_scode: field.scode,
                hb_bud_class: '',
                hb_memo: field.label,
                hb_price: String(fieldValue),
                hb_person: '1',
                hb_month: '1',
                hb_amount: String(fieldValue),
                hb_funding: field.funding || '04',
              });
              
              budgetItems.push({
                code: `${q.code}_${field.key}`,
                section: q.section,
                label: field.label,
                monthly: Math.round(fieldValue / 12),
                annual: fieldValue
              });
            }
          });
        } catch { /* ignore */ }
      }
    }
    else if (q.frequency === 'monthly') {
      monthly = value;
      annual = value * 12;
      
      budgetItems.push({
        code: q.code,
        section: q.section,
        label: q.shortLabel || q.question,
        monthly,
        annual
      });
    } else if (q.frequency === 'once') {
      monthly = Math.round(value / 12);
      annual = value;
      
      budgetItems.push({
        code: q.code,
        section: q.section,
        label: q.shortLabel || q.question,
        monthly,
        annual
      });
    }
  });
  
  // 세출 항목 처리
  expenseQuestions.value.forEach(q => {
    // reference(참고용)는 제외
    if (q.frequency === 'reference') return;
    
    // multi-number 타입: 각 필드별로 별도 저장
    if (q.inputType === 'multi-number' && q.fields) {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          q.fields.forEach(field => {
            const fieldValue = Number(parsed[field.key]) || 0;
            if (fieldValue > 0) {
              const annualAmount = fieldValue * 12; // 월 금액 × 12개월
              
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: field.scode || '',
                hb_bud_class: '',
                hb_memo: field.label,
                hb_price: String(fieldValue),
                hb_person: '1',
                hb_month: '12',
                hb_amount: String(annualAmount),
                hb_funding: field.funding || '',
              });
              
              budgetItems.push({
                code: `${q.code}_${field.key}`,
                section: q.section,
                label: field.label,
                monthly: fieldValue,
                annual: annualAmount
              });
            }
          });
        } catch { /* ignore */ }
      }
      return;
    }
    
    // salary 타입: 급여 + 사회보험부담금 별도 저장
    if (q.inputType === 'salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const salary = Number(parsed['salary']) || 0;
          const count = Number(parsed['count']) || 1;
          
          if (salary > 0) {
            const totalSalary = salary * count;
            const annualSalary = totalSalary * 12;
            
            // 급여-보험-퇴직금 연결 그룹 ID (질문 코드 기반)
            const payRelGroup = `salary_${q.code}`;
            
            // 1. 급여 저장
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: q.scode || '1112',
              hb_bud_class: '',
              hb_memo: q.shortLabel || '급여',
              hb_price: String(salary),
              hb_person: String(count),
              hb_month: '12',
              hb_amount: String(annualSalary),
              hb_funding: q.funding || '',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'salary',
            });
            
            budgetItems.push({
              code: q.code,
              section: q.section,
              label: q.shortLabel || q.question,
              monthly: totalSalary,
              annual: annualSalary
            });
            
            // 2. 사회보험부담금 계산 및 저장 (간접비: 1152)
            const config = q.insuranceConfig || {};
            // 1인당 기준으로 계산
            const nationalPension = config.nationalPension ? Math.round(salary * (props.taxData?.tr_yeon || 0)) : 0;
            const healthInsurance = config.healthInsurance ? Math.round(salary * (props.taxData?.tr_gun || 0)) : 0;
            const longTermCare = config.longTermCare ? Math.round(healthInsurance * (props.taxData?.tr_jang || 0)) : 0;
            const employmentInsurance = config.employmentInsurance ? Math.round(salary * (props.taxData?.tr_go || 0)) : 0;
            const unemployment = config.unemployment ? Math.round(salary * (props.taxData?.tr_sil || 0)) : 0;
            const industrialAccident = config.industrialAccident ? Math.round(salary * (props.taxData?.tr_san || 0)) : 0;
            
            // 1인당 월 사회보험부담금
            const perPersonInsurance = nationalPension + healthInsurance + longTermCare + employmentInsurance + unemployment + industrialAccident;
            // 정확한 총액 = 월 총 급여 기준 계산 × 12
            const totalMonthlyInsurance = (config.nationalPension ? Math.round(totalSalary * (props.taxData?.tr_yeon || 0)) : 0) +
                                          (config.healthInsurance ? Math.round(totalSalary * (props.taxData?.tr_gun || 0)) : 0) +
                                          (config.longTermCare ? Math.round(Math.round(totalSalary * (props.taxData?.tr_gun || 0)) * (props.taxData?.tr_jang || 0)) : 0) +
                                          (config.employmentInsurance ? Math.round(totalSalary * (props.taxData?.tr_go || 0)) : 0) +
                                          (config.unemployment ? Math.round(totalSalary * (props.taxData?.tr_sil || 0)) : 0) +
                                          (config.industrialAccident ? Math.round(totalSalary * (props.taxData?.tr_san || 0)) : 0);
            const annualInsurance = totalMonthlyInsurance * 12;
            
            if (annualInsurance > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1152', // 사회보험부담금(간접비)
                hb_bud_class: '',
                hb_memo: `${q.shortLabel || '급여'} 사회보험부담금`,
                hb_price: String(perPersonInsurance),
                hb_person: String(count),
                hb_month: '12',
                hb_amount: String(annualInsurance),
                hb_funding: '',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'insurance',
              });
              
              budgetItems.push({
                code: `${q.code}_insurance`,
                section: q.section,
                label: `${q.shortLabel} 사회보험부담금`,
                monthly: totalMonthlyInsurance,
                annual: annualInsurance
              });
            }
            
            // 3. 퇴직금 계산 및 저장 (간접비: 1142)
            if (config.retirement) {
              // 1인당 월 퇴직금
              const perPersonRetirement = Math.round(salary / 12);
              // 정확한 총액 = (월 총 급여 × 12) / 12 = 월 총 급여
              const annualRetirement = totalSalary * 12 / 12; // = totalSalary
              
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1142', // 퇴직금(간접비)
                hb_bud_class: '',
                hb_memo: `${q.shortLabel || '급여'} 퇴직금`,
                hb_price: String(perPersonRetirement),
                hb_person: String(count),
                hb_month: '12',
                hb_amount: String(annualRetirement),
                hb_funding: '',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'retirement',
              });
              
              budgetItems.push({
                code: `${q.code}_retirement`,
                section: q.section,
                label: `${q.shortLabel} 퇴직금`,
                monthly: Math.round(annualRetirement / 12),
                annual: annualRetirement
              });
            }
          }
        } catch { /* ignore */ }
      }
      return;
    }
    
    // director-salary 타입: 대표자/일반 센터장 구분하여 저장
    if (q.inputType === 'director-salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const hasCeo = parsed['hasCeo'];
          const ceoSalary = Number(parsed['ceoSalary']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          const directorCount = Number(parsed['directorCount']) || 0;
          const directorSalary = Number(parsed['directorSalary']) || 0;
          
          // 대표자 저장 (고용/산재/퇴직금 제외)
          if (hasCeo && ceoSalary > 0 && ceoCount > 0) {
            const totalCeoSalary = ceoSalary * ceoCount;
            const annualCeoSalary = totalCeoSalary * 12;
            const payRelGroup = `salary_${q.code}_ceo`;
            
            // 대표자 급여
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: q.scode || '1112',
              hb_bud_class: '',
              hb_memo: '센터장(대표자) 급여',
              hb_price: String(ceoSalary),
              hb_person: String(ceoCount),
              hb_month: '12',
              hb_amount: String(annualCeoSalary),
              hb_funding: q.funding || '',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'salary',
            });
            
            budgetItems.push({
              code: `${q.code}_ceo`,
              section: q.section,
              label: '센터장(대표자) 급여',
              monthly: totalCeoSalary,
              annual: annualCeoSalary
            });
            
            // 대표자 사회보험부담금 (국민연금, 건강보험, 장기요양만) - 1인당 기준
            const perPersonNationalPension = Math.round(ceoSalary * (props.taxData?.tr_yeon || 0));
            const perPersonHealthInsurance = Math.round(ceoSalary * (props.taxData?.tr_gun || 0));
            const perPersonLongTermCare = Math.round(perPersonHealthInsurance * (props.taxData?.tr_jang || 0));
            const perPersonInsurance = perPersonNationalPension + perPersonHealthInsurance + perPersonLongTermCare;
            
            // 정확한 총액 (월 총 급여 기준)
            const totalNationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
            const totalHealthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
            const totalLongTermCare = Math.round(totalHealthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = totalNationalPension + totalHealthInsurance + totalLongTermCare;
            const annualInsurance = monthlyInsurance * 12;
            
            if (annualInsurance > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1152',
                hb_bud_class: '',
                hb_memo: '센터장(대표자) 사회보험부담금',
                hb_price: String(perPersonInsurance),
                hb_person: String(ceoCount),
                hb_month: '12',
                hb_amount: String(annualInsurance),
                hb_funding: '',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'insurance',
              });
              
              budgetItems.push({
                code: `${q.code}_ceo_insurance`,
                section: q.section,
                label: '센터장(대표자) 사회보험부담금',
                monthly: monthlyInsurance,
                annual: annualInsurance
              });
            }
          }
          
          // 일반 센터장 저장 (모든 보험 + 퇴직금)
          if (directorCount > 0 && directorSalary > 0) {
            const totalDirectorSalary = directorSalary * directorCount;
            const annualDirectorSalary = totalDirectorSalary * 12;
            const payRelGroup = `salary_${q.code}_director`;
            
            // 일반 센터장 급여
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: q.scode || '1112',
              hb_bud_class: '',
              hb_memo: '센터장 급여',
              hb_price: String(directorSalary),
              hb_person: String(directorCount),
              hb_month: '12',
              hb_amount: String(annualDirectorSalary),
              hb_funding: q.funding || '',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'salary',
            });
            
            budgetItems.push({
              code: `${q.code}_director`,
              section: q.section,
              label: '센터장 급여',
              monthly: totalDirectorSalary,
              annual: annualDirectorSalary
            });
            
            // 일반 센터장 사회보험부담금 (1인당 기준)
            const perPersonNationalPension = Math.round(directorSalary * (props.taxData?.tr_yeon || 0));
            const perPersonHealthInsurance = Math.round(directorSalary * (props.taxData?.tr_gun || 0));
            const perPersonLongTermCare = Math.round(perPersonHealthInsurance * (props.taxData?.tr_jang || 0));
            const perPersonEmploymentInsurance = Math.round(directorSalary * (props.taxData?.tr_go || 0));
            const perPersonUnemployment = Math.round(directorSalary * (props.taxData?.tr_sil || 0));
            const perPersonIndustrialAccident = Math.round(directorSalary * (props.taxData?.tr_san || 0));
            const perPersonInsurance = perPersonNationalPension + perPersonHealthInsurance + perPersonLongTermCare + perPersonEmploymentInsurance + perPersonUnemployment + perPersonIndustrialAccident;
            
            // 정확한 총액 (월 총 급여 기준)
            const totalNationalPension = Math.round(totalDirectorSalary * (props.taxData?.tr_yeon || 0));
            const totalHealthInsurance = Math.round(totalDirectorSalary * (props.taxData?.tr_gun || 0));
            const totalLongTermCare = Math.round(totalHealthInsurance * (props.taxData?.tr_jang || 0));
            const totalEmploymentInsurance = Math.round(totalDirectorSalary * (props.taxData?.tr_go || 0));
            const totalUnemployment = Math.round(totalDirectorSalary * (props.taxData?.tr_sil || 0));
            const totalIndustrialAccident = Math.round(totalDirectorSalary * (props.taxData?.tr_san || 0));
            const monthlyInsurance = totalNationalPension + totalHealthInsurance + totalLongTermCare + totalEmploymentInsurance + totalUnemployment + totalIndustrialAccident;
            const annualInsurance = monthlyInsurance * 12;
            
            if (annualInsurance > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1152',
                hb_bud_class: '',
                hb_memo: '센터장 사회보험부담금',
                hb_price: String(perPersonInsurance),
                hb_person: String(directorCount),
                hb_month: '12',
                hb_amount: String(annualInsurance),
                hb_funding: '',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'insurance',
              });
              
              budgetItems.push({
                code: `${q.code}_director_insurance`,
                section: q.section,
                label: '센터장 사회보험부담금',
                monthly: monthlyInsurance,
                annual: annualInsurance
              });
            }
            
            // 일반 센터장 퇴직금 (1인당 기준)
            const perPersonRetirement = Math.round(directorSalary / 12);
            // 정확한 총액 = 월 총 급여
            const annualRetirement = totalDirectorSalary;
            
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: '1142',
              hb_bud_class: '',
              hb_memo: '센터장 퇴직금',
              hb_price: String(perPersonRetirement),
              hb_person: String(directorCount),
              hb_month: '12',
              hb_amount: String(annualRetirement),
              hb_funding: '',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'retirement',
            });
            
            budgetItems.push({
              code: `${q.code}_director_retirement`,
              section: q.section,
              label: '센터장 퇴직금',
              monthly: Math.round(annualRetirement / 12),
              annual: annualRetirement
            });
          }
        } catch { /* ignore */ }
      }
      return;
    }
    
    // caregiver-salary 타입: 대표자/일반 구분하여 저장
    if (q.inputType === 'caregiver-salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const hasCeo = parsed['hasCeo'];
          const ceoHourlyWage = Number(parsed['ceoHourlyWage']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          const caregiverCount = Number(parsed['caregiverCount']) || targetClientsCount.value;
          const caregiverHourlyWage = Number(parsed['caregiverHourlyWage']) || 0;
          
          // 대표자 저장 (고용/산재/퇴직금 제외)
          if (hasCeo && ceoHourlyWage > 0 && ceoCount > 0) {
            const monthlySalary = ceoHourlyWage * 60;
            const totalCeoSalary = monthlySalary * ceoCount;
            const annualCeoSalary = totalCeoSalary * 12;
            const payRelGroup = `salary_${q.code}_ceo`;
            
            // 대표자 급여
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: q.scode || '1111',
              hb_bud_class: '',
              hb_memo: '요양보호사(대표자) 급여',
              hb_price: String(monthlySalary),
              hb_person: String(ceoCount),
              hb_month: '12',
              hb_amount: String(annualCeoSalary),
              hb_funding: q.funding || '06',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'salary',
            });
            
            budgetItems.push({
              code: `${q.code}_ceo`,
              section: q.section,
              label: '요양보호사(대표자) 급여',
              monthly: totalCeoSalary,
              annual: annualCeoSalary
            });
            
            // 대표자 사회보험부담금 (국민연금, 건강보험, 장기요양만) - 1인당 기준
            const perPersonNationalPension = Math.round(monthlySalary * (props.taxData?.tr_yeon || 0));
            const perPersonHealthInsurance = Math.round(monthlySalary * (props.taxData?.tr_gun || 0));
            const perPersonLongTermCare = Math.round(perPersonHealthInsurance * (props.taxData?.tr_jang || 0));
            const perPersonInsurance = perPersonNationalPension + perPersonHealthInsurance + perPersonLongTermCare;
            
            // 정확한 총액 (월 총 급여 기준)
            const totalNationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
            const totalHealthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
            const totalLongTermCare = Math.round(totalHealthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = totalNationalPension + totalHealthInsurance + totalLongTermCare;
            const annualInsurance = monthlyInsurance * 12;
            
            if (annualInsurance > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1151',
                hb_bud_class: '',
                hb_memo: '요양보호사(대표자) 사회보험부담금',
                hb_price: String(perPersonInsurance),
                hb_person: String(ceoCount),
                hb_month: '12',
                hb_amount: String(annualInsurance),
                hb_funding: '06',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'insurance',
              });
              
              budgetItems.push({
                code: `${q.code}_ceo_insurance`,
                section: q.section,
                label: '요양보호사(대표자) 사회보험부담금',
                monthly: monthlyInsurance,
                annual: annualInsurance
              });
            }
          }
          
          // 일반 요양보호사 저장 (모든 보험 + 퇴직금)
          if (caregiverCount > 0 && caregiverHourlyWage > 0) {
            const monthlySalary = caregiverHourlyWage * 60;
            const totalCaregiverSalary = monthlySalary * caregiverCount;
            const annualCaregiverSalary = totalCaregiverSalary * 12;
            const payRelGroup = `salary_${q.code}_caregiver`;
            
            // 일반 요양보호사 급여
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: q.scode || '1111',
              hb_bud_class: '',
              hb_memo: '요양보호사 급여',
              hb_price: String(monthlySalary),
              hb_person: String(caregiverCount),
              hb_month: '12',
              hb_amount: String(annualCaregiverSalary),
              hb_funding: q.funding || '06',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'salary',
            });
            
            budgetItems.push({
              code: `${q.code}_caregiver`,
              section: q.section,
              label: '요양보호사 급여',
              monthly: totalCaregiverSalary,
              annual: annualCaregiverSalary
            });
            
            // 일반 요양보호사 사회보험부담금 (1인당 기준)
            const perPersonNationalPension = Math.round(monthlySalary * (props.taxData?.tr_yeon || 0));
            const perPersonHealthInsurance = Math.round(monthlySalary * (props.taxData?.tr_gun || 0));
            const perPersonLongTermCare = Math.round(perPersonHealthInsurance * (props.taxData?.tr_jang || 0));
            const perPersonEmploymentInsurance = Math.round(monthlySalary * (props.taxData?.tr_go || 0));
            const perPersonUnemployment = Math.round(monthlySalary * (props.taxData?.tr_sil || 0));
            const perPersonIndustrialAccident = Math.round(monthlySalary * (props.taxData?.tr_san || 0));
            const perPersonInsurance = perPersonNationalPension + perPersonHealthInsurance + perPersonLongTermCare + perPersonEmploymentInsurance + perPersonUnemployment + perPersonIndustrialAccident;
            
            // 정확한 총액 (월 총 급여 기준)
            const totalNationalPension = Math.round(totalCaregiverSalary * (props.taxData?.tr_yeon || 0));
            const totalHealthInsurance = Math.round(totalCaregiverSalary * (props.taxData?.tr_gun || 0));
            const totalLongTermCare = Math.round(totalHealthInsurance * (props.taxData?.tr_jang || 0));
            const totalEmploymentInsurance = Math.round(totalCaregiverSalary * (props.taxData?.tr_go || 0));
            const totalUnemployment = Math.round(totalCaregiverSalary * (props.taxData?.tr_sil || 0));
            const totalIndustrialAccident = Math.round(totalCaregiverSalary * (props.taxData?.tr_san || 0));
            const monthlyInsurance = totalNationalPension + totalHealthInsurance + totalLongTermCare + totalEmploymentInsurance + totalUnemployment + totalIndustrialAccident;
            const annualInsurance = monthlyInsurance * 12;
            
            if (annualInsurance > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1151',
                hb_bud_class: '',
                hb_memo: '요양보호사 사회보험부담금',
                hb_price: String(perPersonInsurance),
                hb_person: String(caregiverCount),
                hb_month: '12',
                hb_amount: String(annualInsurance),
                hb_funding: '06',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'insurance',
              });
              
              budgetItems.push({
                code: `${q.code}_caregiver_insurance`,
                section: q.section,
                label: '요양보호사 사회보험부담금',
                monthly: monthlyInsurance,
                annual: annualInsurance
              });
            }
            
            // 일반 요양보호사 퇴직금 (1인당 기준)
            const perPersonRetirement = Math.round(monthlySalary / 12);
            // 정확한 총액 = 월 총 급여
            const annualRetirement = totalCaregiverSalary;
            
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: '1141',
              hb_bud_class: '',
              hb_memo: '요양보호사 퇴직금',
              hb_price: String(perPersonRetirement),
              hb_person: String(caregiverCount),
              hb_month: '12',
              hb_amount: String(annualRetirement),
              hb_funding: '06',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'retirement',
            });
            
            budgetItems.push({
              code: `${q.code}_caregiver_retirement`,
              section: q.section,
              label: '요양보호사 퇴직금',
              monthly: Math.round(annualRetirement / 12),
              annual: annualRetirement
            });
          }
        } catch { /* ignore */ }
      }
      return;
    }
    
    // social-worker-salary 타입: 대표자/일반 구분하여 저장, 가산금 세입 추가
    if (q.inputType === 'social-worker-salary') {
      const savedAnswer = answers.value[q.code];
      if (savedAnswer && typeof savedAnswer === 'string') {
        try {
          const parsed = JSON.parse(savedAnswer);
          const hasCeo = parsed['hasCeo'];
          const ceoSalary = Number(parsed['ceoSalary']) || 0;
          const ceoCount = Number(parsed['ceoCount']) || 0;
          const workerCount = Number(parsed['workerCount']) || 0;
          const workerSalary = Number(parsed['workerSalary']) || 0;
          
          // 전체 사회복지사 수 (가산금 계산용)
          const totalWorkerCount = (hasCeo ? ceoCount : 0) + workerCount;
          
          // 대표자 저장 (고용/산재/퇴직금 제외)
          if (hasCeo && ceoSalary > 0 && ceoCount > 0) {
            const totalCeoSalary = ceoSalary * ceoCount;
            const annualCeoSalary = totalCeoSalary * 12;
            const payRelGroup = `salary_${q.code}_ceo`;
            
            // 대표자 급여
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: q.scode || '1111',
              hb_bud_class: '',
              hb_memo: '사회복지사(대표자) 급여',
              hb_price: String(ceoSalary),
              hb_person: String(ceoCount),
              hb_month: '12',
              hb_amount: String(annualCeoSalary),
              hb_funding: q.funding || '06',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'salary',
            });
            
            budgetItems.push({
              code: `${q.code}_ceo`,
              section: q.section,
              label: '사회복지사(대표자) 급여',
              monthly: totalCeoSalary,
              annual: annualCeoSalary
            });
            
            // 대표자 사회보험부담금 (국민연금, 건강보험, 장기요양만) - 1인당 기준
            const perPersonNationalPension = Math.round(ceoSalary * (props.taxData?.tr_yeon || 0));
            const perPersonHealthInsurance = Math.round(ceoSalary * (props.taxData?.tr_gun || 0));
            const perPersonLongTermCare = Math.round(perPersonHealthInsurance * (props.taxData?.tr_jang || 0));
            const perPersonInsurance = perPersonNationalPension + perPersonHealthInsurance + perPersonLongTermCare;
            
            // 정확한 총액 (월 총 급여 기준)
            const totalNationalPension = Math.round(totalCeoSalary * (props.taxData?.tr_yeon || 0));
            const totalHealthInsurance = Math.round(totalCeoSalary * (props.taxData?.tr_gun || 0));
            const totalLongTermCare = Math.round(totalHealthInsurance * (props.taxData?.tr_jang || 0));
            const monthlyInsurance = totalNationalPension + totalHealthInsurance + totalLongTermCare;
            const annualInsurance = monthlyInsurance * 12;
            
            if (annualInsurance > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1151',
                hb_bud_class: '',
                hb_memo: '사회복지사(대표자) 사회보험부담금',
                hb_price: String(perPersonInsurance),
                hb_person: String(ceoCount),
                hb_month: '12',
                hb_amount: String(annualInsurance),
                hb_funding: '06',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'insurance',
              });
              
              budgetItems.push({
                code: `${q.code}_ceo_insurance`,
                section: q.section,
                label: '사회복지사(대표자) 사회보험부담금',
                monthly: monthlyInsurance,
                annual: annualInsurance
              });
            }
          }
          
          // 일반 사회복지사 저장 (모든 보험 + 퇴직금)
          if (workerCount > 0 && workerSalary > 0) {
            const totalWorkerSalary = workerSalary * workerCount;
            const annualWorkerSalary = totalWorkerSalary * 12;
            const payRelGroup = `salary_${q.code}_worker`;
            
            // 일반 사회복지사 급여
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: q.scode || '1111',
              hb_bud_class: '',
              hb_memo: '사회복지사 급여',
              hb_price: String(workerSalary),
              hb_person: String(workerCount),
              hb_month: '12',
              hb_amount: String(annualWorkerSalary),
              hb_funding: q.funding || '06',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'salary',
            });
            
            budgetItems.push({
              code: `${q.code}_worker`,
              section: q.section,
              label: '사회복지사 급여',
              monthly: totalWorkerSalary,
              annual: annualWorkerSalary
            });
            
            // 일반 사회복지사 사회보험부담금 (1인당 기준)
            const perPersonNationalPension = Math.round(workerSalary * (props.taxData?.tr_yeon || 0));
            const perPersonHealthInsurance = Math.round(workerSalary * (props.taxData?.tr_gun || 0));
            const perPersonLongTermCare = Math.round(perPersonHealthInsurance * (props.taxData?.tr_jang || 0));
            const perPersonEmploymentInsurance = Math.round(workerSalary * (props.taxData?.tr_go || 0));
            const perPersonUnemployment = Math.round(workerSalary * (props.taxData?.tr_sil || 0));
            const perPersonIndustrialAccident = Math.round(workerSalary * (props.taxData?.tr_san || 0));
            const perPersonInsurance = perPersonNationalPension + perPersonHealthInsurance + perPersonLongTermCare + perPersonEmploymentInsurance + perPersonUnemployment + perPersonIndustrialAccident;
            
            // 정확한 총액 (월 총 급여 기준)
            const totalNationalPension = Math.round(totalWorkerSalary * (props.taxData?.tr_yeon || 0));
            const totalHealthInsurance = Math.round(totalWorkerSalary * (props.taxData?.tr_gun || 0));
            const totalLongTermCare = Math.round(totalHealthInsurance * (props.taxData?.tr_jang || 0));
            const totalEmploymentInsurance = Math.round(totalWorkerSalary * (props.taxData?.tr_go || 0));
            const totalUnemployment = Math.round(totalWorkerSalary * (props.taxData?.tr_sil || 0));
            const totalIndustrialAccident = Math.round(totalWorkerSalary * (props.taxData?.tr_san || 0));
            const monthlyInsurance = totalNationalPension + totalHealthInsurance + totalLongTermCare + totalEmploymentInsurance + totalUnemployment + totalIndustrialAccident;
            const annualInsurance = monthlyInsurance * 12;
            
            if (annualInsurance > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'OUT',
                hb_scode: '1151',
                hb_bud_class: '',
                hb_memo: '사회복지사 사회보험부담금',
                hb_price: String(perPersonInsurance),
                hb_person: String(workerCount),
                hb_month: '12',
                hb_amount: String(annualInsurance),
                hb_funding: '06',
                pay_rel_group: payRelGroup,
                pay_rel_type: 'insurance',
              });
              
              budgetItems.push({
                code: `${q.code}_worker_insurance`,
                section: q.section,
                label: '사회복지사 사회보험부담금',
                monthly: monthlyInsurance,
                annual: annualInsurance
              });
            }
            
            // 일반 사회복지사 퇴직금 (1인당 기준)
            const perPersonRetirement = Math.round(workerSalary / 12);
            // 정확한 총액 = 월 총 급여
            const annualRetirement = totalWorkerSalary;
            
            generatedEntries.push({
              m_sisul_code: sisulCode,
              hb_year: year,
              hb_gubun: 'OUT',
              hb_scode: '1141',
              hb_bud_class: '',
              hb_memo: '사회복지사 퇴직금',
              hb_price: String(perPersonRetirement),
              hb_person: String(workerCount),
              hb_month: '12',
              hb_amount: String(annualRetirement),
              hb_funding: '06',
              pay_rel_group: payRelGroup,
              pay_rel_type: 'retirement',
            });
            
            budgetItems.push({
              code: `${q.code}_worker_retirement`,
              section: q.section,
              label: '사회복지사 퇴직금',
              monthly: Math.round(annualRetirement / 12),
              annual: annualRetirement
            });
          }
          
          // 가산금 세입 추가 (전체 사회복지사 수 기준)
          const targetClients = parseNumber(String(answers.value['revenue_target_clients'])) || 0;
          if (targetClients > 0 && suga && totalWorkerCount > 0) {
            const clientBillingAmount = sugaMoney * 20;
            const bonusScore = getSocialWorkerBonusPoint(totalWorkerCount);
            const monthlyBonus = Math.round((clientBillingAmount * 0.85 / targetClients) * bonusScore * 1.8 * targetClients);
            const annualBonus = monthlyBonus * 12;
            
            if (annualBonus > 0) {
              generatedEntries.push({
                m_sisul_code: sisulCode,
                hb_year: year,
                hb_gubun: 'IN',
                hb_scode: '613',
                hb_bud_class: '',
                hb_memo: '사회복지사 가산금',
                hb_price: String(monthlyBonus),
                hb_person: '1',
                hb_month: '12',
                hb_amount: String(annualBonus),
                hb_funding: '06',
              });
              
              budgetItems.push({
                code: `${q.code}_bonus`,
                section: '세입',
                label: '사회복지사 가산금',
                monthly: monthlyBonus,
                annual: annualBonus
              });
            }
          }
        } catch { /* ignore */ }
      }
      return;
    }
    
    const value = parseNumber(String(answers.value[q.code])) || 0;
    let monthly = 0;
    let annual = 0;
    
    // Legacy 처리 (제거 예정)
    if (q.code === 'expense_social_worker_salary_legacy') {
      const count = 2; // 기본 2명 (Q&A에서 제외됨)
      monthly = value * count;
      annual = monthly * 12;
    } else if (q.frequency === 'monthly') {
      monthly = value;
      annual = value * 12;
    } else if (q.frequency === 'once') {
      monthly = Math.round(value / 12);
      annual = value;
    } else if (q.frequency === 'count') {
      // 인원수는 계산에서 제외
      monthly = 0;
      annual = 0;
    }
    
    budgetItems.push({
      code: q.code,
      section: q.section,
      label: q.shortLabel || q.question,
      monthly,
      annual
    });
  });
  
  // 기본 운영비 항목 자동 추가 (값이 비어있어도 내용이 있어야 함)
  // 수용비 및 수수료 (scode: 132)
  const defaultExpense132Items = [
    '사무용품비',
    '집기류 구입',
    '각종 렌탈비',
    '기타 수용비'
  ];
  
  defaultExpense132Items.forEach(itemName => {
    generatedEntries.push({
      m_sisul_code: sisulCode,
      hb_year: year,
      hb_gubun: 'OUT',
      hb_scode: '132',
      hb_bud_class: '',
      hb_memo: itemName,
      hb_price: '',
      hb_person: '',
      hb_month: '',
      hb_amount: '',
      hb_funding: ''
    });
  });
  
  // 공공요금 및 각종 세금공과금 (scode: 133)
  const defaultExpense133Items = [
    '인터넷 및 전화요금',
    '전기요금',
    '각종 공공요금',
    '각종 보험금',
    '협회비'
  ];
  
  defaultExpense133Items.forEach(itemName => {
    generatedEntries.push({
      m_sisul_code: sisulCode,
      hb_year: year,
      hb_gubun: 'OUT',
      hb_scode: '133',
      hb_bud_class: '',
      hb_memo: itemName,
      hb_price: '',
      hb_person: '',
      hb_month: '',
      hb_amount: '',
      hb_funding: ''
    });
  });
  
  // 생성된 예산 엔트리 저장
  budgetEntries.value = generatedEntries;
  
  const budgetData: BudgetData = {
    year: searchParams.value.lebYear,
    answers: { ...answers.value },
    calculations: {
      totalRevenue: totalRevenue.value,
      totalExpense: totalExpense.value,
      balance: balance.value,
      bonusRevenue: bonusRevenue.value,
      items: budgetItems
    },
    budgetEntries: generatedEntries
  };
  
  emit('complete', budgetData);
};

watch(compositeAnswers, (newVal, oldVal) => {
  if (currentQuestion.value?.inputType === 'composite') {
    saveCurrentAnswer();
  }
  
  // director-salary: 대표자 스위치 해제 시 대표자 관련 값 초기화
  if (currentQuestion.value?.inputType === 'director-salary') {
    if (oldVal?.['hasCeo'] === true && newVal?.['hasCeo'] === false) {
      compositeAnswers.value['ceoSalary'] = '';
      compositeAnswers.value['ceoCount'] = 1;
    }
  }
  
  // social-worker-salary: 대표자 스위치 해제 시 대표자 관련 값 초기화
  if (currentQuestion.value?.inputType === 'social-worker-salary') {
    if (oldVal?.['hasCeo'] === true && newVal?.['hasCeo'] === false) {
      compositeAnswers.value['ceoSalary'] = '';
      compositeAnswers.value['ceoCount'] = 1;
    }
  }
  
  // caregiver-salary: 대표자 스위치 해제 시 대표자 관련 값 초기화
  if (currentQuestion.value?.inputType === 'caregiver-salary') {
    if (oldVal?.['hasCeo'] === true && newVal?.['hasCeo'] === false) {
      compositeAnswers.value['ceoHourlyWage'] = '';
      compositeAnswers.value['ceoCount'] = 1;
    }
  }
}, { deep: true });

// props.year가 변경되면 searchParams.lebYear 동기화
watch(() => props.year, (newYear) => {
  if (newYear && newYear !== searchParams.value.lebYear) {
    searchParams.value.lebYear = newYear;
  }
}, { immediate: true });

// props.sugaList가 변경되면 질문 옵션 업데이트
watch(() => props.sugaList, () => {
  updateSugaOptions();
}, { immediate: true });

onMounted(() => {
  if (totalQuestions.value > 0) {
    loadCurrentAnswer();
    focusFirstInput();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "year-nav-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeYear(-1))),
            disabled: parseInt(searchParams.value.lebYear) <= minYear
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(searchParams.value.lebYear), 1),
            _cache[26] || (_cache[26] = _createElementVNode("span", { class: "year-unit" }, "년", -1))
          ]),
          _createElementVNode("button", {
            class: "year-nav-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeYear(1))),
            disabled: parseInt(searchParams.value.lebYear) >= maxYear
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_8)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["budget-class-badge", budgetClassStyle.value])
        }, [
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(budgetClassIcon.value), 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(budgetClassLabel.value), 1)
        ], 2),
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "sidebar-header" }, [
          _createElementVNode("h2", null, "예산 편성"),
          _createElementVNode("p", null, "질의응답 기반 자동 계산")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock("svg", _hoisted_11, [
              _cache[28] || (_cache[28] = _createElementVNode("circle", {
                class: "progress-bg",
                cx: "50",
                cy: "50",
                r: "45"
              }, null, -1)),
              _createElementVNode("circle", {
                class: "progress-fill",
                cx: "50",
                cy: "50",
                r: "45",
                style: _normalizeStyle({ strokeDashoffset: progressOffset.value })
              }, null, 4)
            ])),
            _createElementVNode("span", _hoisted_12, _toDisplayString(Math.round(progressPercent.value)) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(currentStep.value), 1),
            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "divider" }, "/", -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(totalQuestions.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "summary-header" }, [
              _createElementVNode("span", { class: "dot" }),
              _createElementVNode("span", { class: "label" }, "세입")
            ], -1)),
            _createElementVNode("span", _hoisted_18, _toDisplayString(formatMoney(totalRevenue.value)) + "원", 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "summary-header" }, [
              _createElementVNode("span", { class: "dot" }),
              _createElementVNode("span", { class: "label" }, "세출")
            ], -1)),
            _createElementVNode("span", _hoisted_20, _toDisplayString(formatMoney(totalExpense.value)) + "원", 1)
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["summary-item balance", { negative: balance.value < 0 }])
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_v_icon, {
                size: "16",
                color: balance.value >= 0 ? '#10b981' : '#ef4444'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(balance.value >= 0 ? 'mdi-check-circle' : 'mdi-alert-circle'), 1)
                ]),
                _: 1
              }, 8, ["color"]),
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "label" }, "잔액", -1))
            ]),
            _createElementVNode("span", _hoisted_22, _toDisplayString(formatMoney(balance.value)) + "원", 1)
          ], 2)
        ]),
        (totalExpense.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_v_icon, {
                  size: "18",
                  color: "#374151"
                }, {
                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                    _createTextVNode("mdi-account-cash", -1)
                  ]))]),
                  _: 1
                }),
                _cache[35] || (_cache[35] = _createElementVNode("span", null, "인건비 지출 비율", -1))
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[36] || (_cache[36] = _createElementVNode("span", { class: "labor-cost-label" }, "기준비율", -1)),
                  _createElementVNode("span", _hoisted_27, _toDisplayString(standardLaborCostRate.value) + "%", 1)
                ]),
                _createVNode(_component_v_tooltip, {
                  location: "bottom",
                  "max-width": "320"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createElementVNode("div", _mergeProps(props, {
                      class: ["labor-cost-item current", { warning: isLaborCostBelowStandard.value, safe: !isLaborCostBelowStandard.value }]
                    }), [
                      _cache[38] || (_cache[38] = _createElementVNode("span", { class: "labor-cost-label" }, "현재비율", -1)),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(currentLaborCostRate.value.toFixed(1)) + "%", 1),
                      _createVNode(_component_v_icon, {
                        size: "12",
                        class: "tooltip-icon"
                      }, {
                        default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                          _createTextVNode("mdi-help-circle-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ], 16)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[41] || (_cache[41] = _createElementVNode("div", { class: "tooltip-title" }, "산출근거", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[39] || (_cache[39] = _createElementVNode("span", { class: "tooltip-label" }, "인건비 지출", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(formatMoney(totalLaborCost.value)) + "원", 1)
                      ]),
                      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "tooltip-note" }, "(요양보호사·사회복지사 급여+보험+퇴직금)", -1)),
                      _createElementVNode("div", _hoisted_32, [
                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "tooltip-label" }, "수입", -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(formatMoney(laborCostBaseRevenue.value)) + "원", 1)
                      ]),
                      _cache[43] || (_cache[43] = _createElementVNode("div", { class: "tooltip-note" }, "(장기요양급여+본인부담금+가산금)", -1)),
                      _createElementVNode("div", _hoisted_34, " 비율 = " + _toDisplayString(formatMoney(totalLaborCost.value)) + " ÷ " + _toDisplayString(formatMoney(laborCostBaseRevenue.value)) + " × 100 = " + _toDisplayString(currentLaborCostRate.value.toFixed(1)) + "% ", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["labor-cost-status", { warning: isLaborCostBelowStandard.value }])
              }, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: isLaborCostBelowStandard.value ? '#f59e0b' : '#10b981'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isLaborCostBelowStandard.value ? 'mdi-alert' : 'mdi-check-circle'), 1)
                  ]),
                  _: 1
                }, 8, ["color"]),
                (isLaborCostBelowStandard.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "기준비율 미달"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_36, "기준비율 충족"))
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("nav", _hoisted_37, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-item", { active: currentSection.value === 'revenue', completed: isRevenueCompleted.value }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (goToSection('revenue')))
          }, [
            _createElementVNode("span", _hoisted_38, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                  _createTextVNode("mdi-arrow-down-bold", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "nav-text" }, "세입 항목", -1)),
            _createElementVNode("span", _hoisted_39, _toDisplayString(revenueAnsweredCount.value) + "/" + _toDisplayString(revenueQuestions.value.length), 1)
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(["nav-item", { active: currentSection.value === 'expense', completed: isExpenseCompleted.value }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (goToSection('expense')))
          }, [
            _createElementVNode("span", _hoisted_40, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                  _createTextVNode("mdi-arrow-up-bold", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[47] || (_cache[47] = _createElementVNode("span", { class: "nav-text" }, "세출 항목", -1)),
            _createElementVNode("span", _hoisted_41, _toDisplayString(expenseAnsweredCount.value) + "/" + _toDisplayString(expenseQuestions.value.length), 1)
          ], 2)
        ])
      ]),
      _createElementVNode("main", _hoisted_42, [
        (totalQuestions.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_v_icon, {
                  size: "64",
                  color: "#9ca3af"
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode("mdi-clipboard-text-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[50] || (_cache[50] = _createElementVNode("h3", null, "질문이 준비되지 않았습니다", -1)),
              _cache[51] || (_cache[51] = _createElementVNode("p", null, "세입/세출 질문을 추가해주세요.", -1))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["section-badge", currentSection.value])
                  }, _toDisplayString(currentQuestion.value?.section), 3),
                  _createVNode(_component_v_icon, {
                    size: "16",
                    color: "#9ca3af"
                  }, {
                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                      _createTextVNode("mdi-chevron-right", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_47, "질문 " + _toDisplayString(currentQuestion.value?.sequence), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSectionQuestions.value, (q, idx) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: idx,
                      class: _normalizeClass(["dot", { 
                  active: q.code === currentQuestion.value?.code,
                  filled: answers.value[q.code] !== undefined && answers.value[q.code] !== '',
                  [currentSection.value]: true
                }]),
                      onClick: ($event: any) => (goToQuestion(q.code))
                    }, null, 10, _hoisted_49))
                  }), 128))
                ])
              ]),
              _createVNode(_Transition, {
                name: "slide-fade",
                mode: "out-in",
                onAfterEnter: focusFirstInput
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["question-card", currentSection.value]),
                    key: currentStep.value
                  }, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["question-number", currentSection.value])
                      }, "Q" + _toDisplayString(currentQuestion.value?.sequence), 3)
                    ]),
                    _createElementVNode("h2", _hoisted_51, _toDisplayString(currentQuestion.value?.question), 1),
                    (currentQuestion.value?.hint)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            color: "#7c3aed"
                          }, {
                            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                              _createTextVNode("mdi-lightbulb-on", -1)
                            ]))]),
                            _: 1
                          }),
                          _createElementVNode("span", null, _toDisplayString(currentQuestion.value?.hint), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (currentQuestion.value?.description)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["description-box", currentSection.value])
                        }, [
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_v_icon, {
                              size: "20",
                              color: "#6b7280"
                            }, {
                              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                                _createTextVNode("mdi-information", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            (parsedDescription.value.isList)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_55, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedDescription.value.items, (item, idx) => {
                                    return (_openBlock(), _createElementBlock("li", { key: idx }, [
                                      _createElementVNode("span", _hoisted_56, _toDisplayString(item.number), 1),
                                      _createElementVNode("span", _hoisted_57, _toDisplayString(item.text), 1)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(currentQuestion.value?.description), 1))
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_59, [
                      (currentQuestion.value?.inputType === 'number')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("label", _hoisted_61, _toDisplayString(currentQuestion.value?.suffix === '명' ? '인원수' : '금액'), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass(["input-wrapper", { focused: inputFocused.value, filled: currentAnswer.value, [currentSection.value]: true }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "main-input",
                                placeholder: currentQuestion.value?.placeholder || '0',
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentAnswer).value = $event)),
                                onInput: handleNumberInput,
                                onFocus: _cache[5] || (_cache[5] = ($event: any) => (inputFocused.value = true)),
                                onBlur: _cache[6] || (_cache[6] = ($event: any) => (inputFocused.value = false)),
                                onKeyup: _withKeys(handleEnterKey, ["enter"])
                              }, null, 40, _hoisted_62), [
                                [_vModelText, currentAnswer.value]
                              ]),
                              _createElementVNode("span", _hoisted_63, _toDisplayString((currentQuestion.value?.suffix || '원') + (currentPeriodLabel.value ? ' ' + currentPeriodLabel.value : '')), 1)
                            ], 2)
                          ]))
                        : (currentQuestion.value?.inputType === 'select')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              _cache[57] || (_cache[57] = _createElementVNode("label", { class: "field-label" }, "항목 선택", -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["select-wrapper", currentSection.value])
                              }, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentAnswer).value = $event)),
                                  class: "main-select"
                                }, [
                                  _cache[55] || (_cache[55] = _createElementVNode("option", { value: "" }, "선택하세요", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value?.options, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.value,
                                      value: option.value
                                    }, _toDisplayString(option.label), 9, _hoisted_65))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, currentAnswer.value]
                                ]),
                                _createVNode(_component_v_icon, {
                                  class: "select-arrow",
                                  size: "20"
                                }, {
                                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                    _createTextVNode("mdi-chevron-down", -1)
                                  ]))]),
                                  _: 1
                                })
                              ], 2)
                            ]))
                          : (currentQuestion.value?.inputType === 'composite')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value?.fields, (field) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["composite-field", currentSection.value]),
                                    key: field.key
                                  }, [
                                    _createElementVNode("label", _hoisted_67, _toDisplayString(field.label), 1),
                                    _createElementVNode("div", _hoisted_68, [
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((compositeAnswers.value[field.key]) = $event),
                                        class: "main-select"
                                      }, [
                                        _cache[58] || (_cache[58] = _createElementVNode("option", { value: "" }, "▼ 선택하세요", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (opt) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: opt.value,
                                            value: opt.value
                                          }, _toDisplayString(opt.label), 9, _hoisted_70))
                                        }), 128))
                                      ], 8, _hoisted_69), [
                                        [_vModelSelect, compositeAnswers.value[field.key]]
                                      ]),
                                      _createVNode(_component_v_icon, {
                                        class: "select-arrow",
                                        size: "20"
                                      }, {
                                        default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                                          _createTextVNode("mdi-chevron-down", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ])
                                  ], 2))
                                }), 128))
                              ]))
                            : (currentQuestion.value?.inputType === 'multi-number')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value?.fields, (field) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["multi-number-field", currentSection.value]),
                                      key: field.key
                                    }, [
                                      _createElementVNode("label", _hoisted_72, _toDisplayString(field.label), 1),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value[field.key], [currentSection.value]: true }])
                                      }, [
                                        _createElementVNode("input", {
                                          type: "text",
                                          class: "main-input",
                                          placeholder: '0',
                                          value: formatMultiNumberValue(field.key),
                                          onInput: ($event: any) => (handleMultiNumberInput($event, field.key)),
                                          onKeyup: _withKeys(handleEnterKey, ["enter"])
                                        }, null, 40, _hoisted_73),
                                        (field.suffix)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(field.suffix === '원' && getMultiNumberPeriodLabel.value ? '원 ' + getMultiNumberPeriodLabel.value : field.suffix), 1))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ], 2))
                                  }), 128))
                                ]))
                              : (currentQuestion.value?.inputType === 'salary')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value?.fields, (field) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: field.key,
                                          class: _normalizeClass(["salary-field", currentSection.value])
                                        }, [
                                          _createElementVNode("label", _hoisted_77, _toDisplayString(field.label), 1),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value[field.key], [currentSection.value]: true }])
                                          }, [
                                            _createElementVNode("input", {
                                              type: "text",
                                              class: "main-input",
                                              placeholder: '0',
                                              value: formatMultiNumberValue(field.key),
                                              onInput: ($event: any) => (handleMultiNumberInput($event, field.key)),
                                              onKeyup: _withKeys(handleEnterKey, ["enter"])
                                            }, null, 40, _hoisted_78),
                                            (field.suffix)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(field.suffix === '원' ? '원 / 월' : field.suffix), 1))
                                              : _createCommentVNode("", true)
                                          ], 2)
                                        ], 2))
                                      }), 128))
                                    ]),
                                    (salaryInsurancePreview.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                          _createElementVNode("div", _hoisted_81, [
                                            _createVNode(_component_v_icon, {
                                              size: "18",
                                              color: "#6b7280"
                                            }, {
                                              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                                _createTextVNode("mdi-shield-account", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _cache[61] || (_cache[61] = _createElementVNode("span", null, "사회보험부담금 (사업자 부담분)", -1)),
                                            (!currentQuestion.value?.insuranceConfig?.employmentInsurance)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_82, " (대표자: 고용·산재·퇴직금 제외) "))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("div", _hoisted_84, [
                                              _cache[62] || (_cache[62] = _createElementVNode("span", { class: "summary-label" }, "연간 급여", -1)),
                                              _createElementVNode("span", _hoisted_85, _toDisplayString(formatMoney(salaryInsurancePreview.value.annualSalary)) + "원", 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_86, [
                                              _cache[63] || (_cache[63] = _createElementVNode("span", { class: "summary-label" }, "연간 사회보험부담금", -1)),
                                              _createElementVNode("span", _hoisted_87, _toDisplayString(formatMoney(salaryInsurancePreview.value.annualInsurance - salaryInsurancePreview.value.retirement * 12)) + "원", 1)
                                            ]),
                                            (currentQuestion.value?.insuranceConfig?.retirement)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                                  _cache[64] || (_cache[64] = _createElementVNode("span", { class: "summary-label" }, "연간 퇴직금", -1)),
                                                  _createElementVNode("span", _hoisted_89, _toDisplayString(formatMoney(salaryInsurancePreview.value.retirement * 12)) + "원", 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (currentQuestion.value?.inputType === 'caregiver-salary')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                      _createElementVNode("div", _hoisted_91, [
                                        _createElementVNode("div", _hoisted_92, [
                                          _createVNode(_component_v_icon, {
                                            size: "20",
                                            color: "#6b7280"
                                          }, {
                                            default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                              _createTextVNode("mdi-account-tie", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _cache[66] || (_cache[66] = _createElementVNode("span", null, "대표자(사업주)가 요양보호사로 근무합니까?", -1))
                                        ]),
                                        _createVNode(_component_v_switch, {
                                          modelValue: compositeAnswers.value['hasCeo'],
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compositeAnswers.value['hasCeo']) = $event)),
                                          color: "primary",
                                          "hide-details": "",
                                          density: "compact",
                                          inset: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      (compositeAnswers.value['hasCeo'])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                            _createElementVNode("div", _hoisted_94, [
                                              _createVNode(_component_v_icon, {
                                                size: "16",
                                                color: "#f59e0b"
                                              }, {
                                                default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                                  _createTextVNode("mdi-shield-account", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _cache[68] || (_cache[68] = _createElementVNode("span", null, "대표자 (고용·산재·퇴직금 제외)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_95, [
                                              _createElementVNode("div", _hoisted_96, [
                                                _cache[70] || (_cache[70] = _createElementVNode("label", { class: "field-label" }, "대표자 수", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['ceoCount'], expense: true }])
                                                }, [
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "main-input",
                                                    placeholder: "1",
                                                    value: formatMultiNumberValue('ceoCount'),
                                                    onInput: _cache[9] || (_cache[9] = ($event: any) => (handleMultiNumberInput($event, 'ceoCount'))),
                                                    onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                  }, null, 40, _hoisted_97),
                                                  _cache[69] || (_cache[69] = _createElementVNode("span", { class: "input-suffix" }, "명", -1))
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_98, [
                                                _cache[72] || (_cache[72] = _createElementVNode("label", { class: "field-label" }, "대표자 시급", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['ceoHourlyWage'], expense: true }])
                                                }, [
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "main-input",
                                                    placeholder: "0",
                                                    value: formatMultiNumberValue('ceoHourlyWage'),
                                                    onInput: _cache[10] || (_cache[10] = ($event: any) => (handleMultiNumberInput($event, 'ceoHourlyWage'))),
                                                    onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                  }, null, 40, _hoisted_99),
                                                  _cache[71] || (_cache[71] = _createElementVNode("span", { class: "input-suffix" }, "원 / 시간", -1))
                                                ], 2)
                                              ])
                                            ]),
                                            (Number(compositeAnswers.value['ceoHourlyWage']) > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_100, " 월급 = " + _toDisplayString(formatMoney(Number(compositeAnswers.value['ceoHourlyWage']) * 60)) + "원 (" + _toDisplayString(formatMoney(Number(compositeAnswers.value['ceoHourlyWage']))) + "원 × 60시간) ", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_101, [
                                        _createElementVNode("div", _hoisted_102, [
                                          _createVNode(_component_v_icon, {
                                            size: "16",
                                            color: "#f59e0b"
                                          }, {
                                            default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                              _createTextVNode("mdi-account-group", -1)
                                            ]))]),
                                            _: 1
                                          }),
                                          _cache[74] || (_cache[74] = _createElementVNode("span", null, "일반 요양보호사 (모든 보험·퇴직금 적용)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_103, [
                                          _createElementVNode("div", _hoisted_104, [
                                            _cache[76] || (_cache[76] = _createElementVNode("label", { class: "field-label" }, "요양보호사 수", -1)),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['caregiverCount'], expense: true, disabled: targetClientsCount.value <= 0 }])
                                            }, [
                                              _createElementVNode("input", {
                                                type: "text",
                                                class: "main-input",
                                                placeholder: targetClientsCount.value > 0 ? String(targetClientsCount.value) : '수급자수 먼저 입력',
                                                value: formatMultiNumberValue('caregiverCount'),
                                                onInput: _cache[11] || (_cache[11] = ($event: any) => (handleMultiNumberInput($event, 'caregiverCount'))),
                                                onKeyup: _withKeys(handleEnterKey, ["enter"]),
                                                disabled: targetClientsCount.value <= 0
                                              }, null, 40, _hoisted_105),
                                              _cache[75] || (_cache[75] = _createElementVNode("span", { class: "input-suffix" }, "명", -1))
                                            ], 2),
                                            (targetClientsCount.value > 0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, "기본값: 수급자 수 (" + _toDisplayString(targetClientsCount.value) + "명)", 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_107, "세입 - 목표 수급자수를 먼저 입력하세요"))
                                          ]),
                                          _createElementVNode("div", _hoisted_108, [
                                            _cache[78] || (_cache[78] = _createElementVNode("label", { class: "field-label" }, "시급", -1)),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['caregiverHourlyWage'], expense: true }])
                                            }, [
                                              _createElementVNode("input", {
                                                type: "text",
                                                class: "main-input",
                                                placeholder: "0",
                                                value: formatMultiNumberValue('caregiverHourlyWage'),
                                                onInput: _cache[12] || (_cache[12] = ($event: any) => (handleMultiNumberInput($event, 'caregiverHourlyWage'))),
                                                onKeyup: _withKeys(handleEnterKey, ["enter"])
                                              }, null, 40, _hoisted_109),
                                              _cache[77] || (_cache[77] = _createElementVNode("span", { class: "input-suffix" }, "원 / 시간", -1))
                                            ], 2)
                                          ])
                                        ]),
                                        (Number(compositeAnswers.value['caregiverHourlyWage']) > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, " 월급 = " + _toDisplayString(formatMoney(Number(compositeAnswers.value['caregiverHourlyWage']) * 60)) + "원 (" + _toDisplayString(formatMoney(Number(compositeAnswers.value['caregiverHourlyWage']))) + "원 × 60시간) ", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (caregiverInsurancePreview.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                            _createElementVNode("div", _hoisted_112, [
                                              _createVNode(_component_v_icon, {
                                                size: "18",
                                                color: "#6b7280"
                                              }, {
                                                default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                                  _createTextVNode("mdi-shield-account", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _cache[80] || (_cache[80] = _createElementVNode("span", null, "사회보험부담금 + 퇴직금 (사업자 부담분)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_113, [
                                              (caregiverInsurancePreview.value.ceo)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createElementVNode("div", _hoisted_114, [
                                                      _cache[81] || (_cache[81] = _createElementVNode("span", { class: "summary-label" }, "대표자 연간 급여", -1)),
                                                      _createElementVNode("span", _hoisted_115, _toDisplayString(formatMoney(caregiverInsurancePreview.value.ceo.annualSalary)) + "원", 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_116, [
                                                      _cache[82] || (_cache[82] = _createElementVNode("span", { class: "summary-label" }, "대표자 연간 사회보험부담금", -1)),
                                                      _createElementVNode("span", _hoisted_117, _toDisplayString(formatMoney(caregiverInsurancePreview.value.ceo.annualInsurance)) + "원", 1)
                                                    ])
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              (caregiverInsurancePreview.value.caregiver)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createElementVNode("div", _hoisted_118, [
                                                      _cache[83] || (_cache[83] = _createElementVNode("span", { class: "summary-label" }, "요양보호사 연간 급여", -1)),
                                                      _createElementVNode("span", _hoisted_119, _toDisplayString(formatMoney(caregiverInsurancePreview.value.caregiver.annualSalary)) + "원", 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_120, [
                                                      _cache[84] || (_cache[84] = _createElementVNode("span", { class: "summary-label" }, "요양보호사 연간 사회보험+퇴직금", -1)),
                                                      _createElementVNode("span", _hoisted_121, _toDisplayString(formatMoney(caregiverInsurancePreview.value.caregiver.annualInsurance)) + "원", 1)
                                                    ])
                                                  ], 64))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", _hoisted_122, [
                                                _cache[85] || (_cache[85] = _createElementVNode("span", { class: "summary-label" }, "총 연간 비용", -1)),
                                                _createElementVNode("span", _hoisted_123, _toDisplayString(formatMoney(caregiverInsurancePreview.value.totalAnnual)) + "원", 1)
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (currentQuestion.value?.inputType === 'director-salary')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                        _createElementVNode("div", _hoisted_125, [
                                          _createElementVNode("div", _hoisted_126, [
                                            _createVNode(_component_v_icon, {
                                              size: "20",
                                              color: "#6b7280"
                                            }, {
                                              default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                                _createTextVNode("mdi-account-tie", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _cache[87] || (_cache[87] = _createElementVNode("span", null, "대표자(사업주)가 센터장으로 근무합니까?", -1))
                                          ]),
                                          _createVNode(_component_v_switch, {
                                            modelValue: compositeAnswers.value['hasCeo'],
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((compositeAnswers.value['hasCeo']) = $event)),
                                            color: "primary",
                                            "hide-details": "",
                                            density: "compact",
                                            inset: ""
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        (compositeAnswers.value['hasCeo'])
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                              _createElementVNode("div", _hoisted_128, [
                                                _createVNode(_component_v_icon, {
                                                  size: "16",
                                                  color: "#f59e0b"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                                                    _createTextVNode("mdi-shield-account", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _cache[89] || (_cache[89] = _createElementVNode("span", null, "대표자 (고용·산재·퇴직금 제외)", -1))
                                              ]),
                                              _createElementVNode("div", _hoisted_129, [
                                                _createElementVNode("div", _hoisted_130, [
                                                  _cache[91] || (_cache[91] = _createElementVNode("label", { class: "field-label" }, "대표자 수", -1)),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['ceoCount'], expense: true }])
                                                  }, [
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "main-input",
                                                      placeholder: "1",
                                                      value: formatMultiNumberValue('ceoCount'),
                                                      onInput: _cache[14] || (_cache[14] = ($event: any) => (handleMultiNumberInput($event, 'ceoCount'))),
                                                      onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                    }, null, 40, _hoisted_131),
                                                    _cache[90] || (_cache[90] = _createElementVNode("span", { class: "input-suffix" }, "명", -1))
                                                  ], 2)
                                                ]),
                                                _createElementVNode("div", _hoisted_132, [
                                                  _cache[93] || (_cache[93] = _createElementVNode("label", { class: "field-label" }, "대표자 월 급여", -1)),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['ceoSalary'], expense: true }])
                                                  }, [
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "main-input",
                                                      placeholder: "0",
                                                      value: formatMultiNumberValue('ceoSalary'),
                                                      onInput: _cache[15] || (_cache[15] = ($event: any) => (handleMultiNumberInput($event, 'ceoSalary'))),
                                                      onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                    }, null, 40, _hoisted_133),
                                                    _cache[92] || (_cache[92] = _createElementVNode("span", { class: "input-suffix" }, "원 / 월", -1))
                                                  ], 2)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_134, [
                                          _createElementVNode("div", _hoisted_135, [
                                            _createVNode(_component_v_icon, {
                                              size: "16",
                                              color: "#f59e0b"
                                            }, {
                                              default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                                                _createTextVNode("mdi-account-group", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _cache[95] || (_cache[95] = _createElementVNode("span", null, "일반 센터장 (모든 보험·퇴직금 적용)", -1))
                                          ]),
                                          _createElementVNode("div", _hoisted_136, [
                                            _createElementVNode("div", _hoisted_137, [
                                              _cache[97] || (_cache[97] = _createElementVNode("label", { class: "field-label" }, "일반 센터장 수", -1)),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['directorCount'], expense: true }])
                                              }, [
                                                _createElementVNode("input", {
                                                  type: "text",
                                                  class: "main-input",
                                                  placeholder: "0",
                                                  value: formatMultiNumberValue('directorCount'),
                                                  onInput: _cache[16] || (_cache[16] = ($event: any) => (handleMultiNumberInput($event, 'directorCount'))),
                                                  onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                }, null, 40, _hoisted_138),
                                                _cache[96] || (_cache[96] = _createElementVNode("span", { class: "input-suffix" }, "명", -1))
                                              ], 2)
                                            ]),
                                            _createElementVNode("div", _hoisted_139, [
                                              _cache[99] || (_cache[99] = _createElementVNode("label", { class: "field-label" }, "일반 센터장 월 급여", -1)),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['directorSalary'], expense: true }])
                                              }, [
                                                _createElementVNode("input", {
                                                  type: "text",
                                                  class: "main-input",
                                                  placeholder: "0",
                                                  value: formatMultiNumberValue('directorSalary'),
                                                  onInput: _cache[17] || (_cache[17] = ($event: any) => (handleMultiNumberInput($event, 'directorSalary'))),
                                                  onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                }, null, 40, _hoisted_140),
                                                _cache[98] || (_cache[98] = _createElementVNode("span", { class: "input-suffix" }, "원 / 월", -1))
                                              ], 2)
                                            ])
                                          ])
                                        ]),
                                        (directorInsurancePreview.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                              _createElementVNode("div", _hoisted_142, [
                                                _createVNode(_component_v_icon, {
                                                  size: "18",
                                                  color: "#6b7280"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                                                    _createTextVNode("mdi-shield-account", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _cache[101] || (_cache[101] = _createElementVNode("span", null, "사회보험부담금 + 퇴직금 (사업자 부담분)", -1))
                                              ]),
                                              _createElementVNode("div", _hoisted_143, [
                                                (directorInsurancePreview.value.ceo)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createElementVNode("div", _hoisted_144, [
                                                        _cache[102] || (_cache[102] = _createElementVNode("span", { class: "summary-label" }, "대표자 연간 급여", -1)),
                                                        _createElementVNode("span", _hoisted_145, _toDisplayString(formatMoney(directorInsurancePreview.value.ceo.annualSalary)) + "원", 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_146, [
                                                        _cache[103] || (_cache[103] = _createElementVNode("span", { class: "summary-label" }, "대표자 연간 사회보험부담금", -1)),
                                                        _createElementVNode("span", _hoisted_147, _toDisplayString(formatMoney(directorInsurancePreview.value.ceo.annualInsurance)) + "원", 1)
                                                      ])
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                (directorInsurancePreview.value.director)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createElementVNode("div", _hoisted_148, [
                                                        _cache[104] || (_cache[104] = _createElementVNode("span", { class: "summary-label" }, "일반 센터장 연간 급여", -1)),
                                                        _createElementVNode("span", _hoisted_149, _toDisplayString(formatMoney(directorInsurancePreview.value.director.annualSalary)) + "원", 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_150, [
                                                        _cache[105] || (_cache[105] = _createElementVNode("span", { class: "summary-label" }, "일반 센터장 연간 사회보험+퇴직금", -1)),
                                                        _createElementVNode("span", _hoisted_151, _toDisplayString(formatMoney(directorInsurancePreview.value.director.annualInsurance)) + "원", 1)
                                                      ])
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_152, [
                                                  _cache[106] || (_cache[106] = _createElementVNode("span", { class: "summary-label" }, "총 연간 비용", -1)),
                                                  _createElementVNode("span", _hoisted_153, _toDisplayString(formatMoney(directorInsurancePreview.value.totalAnnual)) + "원", 1)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (currentQuestion.value?.inputType === 'social-worker-salary')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                          _createElementVNode("div", _hoisted_155, [
                                            _createElementVNode("div", _hoisted_156, [
                                              _createVNode(_component_v_icon, {
                                                size: "20",
                                                color: "#6b7280"
                                              }, {
                                                default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                                                  _createTextVNode("mdi-account-tie", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _cache[108] || (_cache[108] = _createElementVNode("span", null, "대표자(사업주)가 사회복지사로 근무합니까?", -1))
                                            ]),
                                            _createVNode(_component_v_switch, {
                                              modelValue: compositeAnswers.value['hasCeo'],
                                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((compositeAnswers.value['hasCeo']) = $event)),
                                              color: "primary",
                                              "hide-details": "",
                                              density: "compact",
                                              inset: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          (compositeAnswers.value['hasCeo'])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                                _createElementVNode("div", _hoisted_158, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "16",
                                                    color: "#f59e0b"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                                                      _createTextVNode("mdi-shield-account", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[110] || (_cache[110] = _createElementVNode("span", null, "대표자 (고용·산재·퇴직금 제외)", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_159, [
                                                  _createElementVNode("div", _hoisted_160, [
                                                    _cache[112] || (_cache[112] = _createElementVNode("label", { class: "field-label" }, "대표자 수", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['ceoCount'], expense: true }])
                                                    }, [
                                                      _createElementVNode("input", {
                                                        type: "text",
                                                        class: "main-input",
                                                        placeholder: "1",
                                                        value: formatMultiNumberValue('ceoCount'),
                                                        onInput: _cache[19] || (_cache[19] = ($event: any) => (handleMultiNumberInput($event, 'ceoCount'))),
                                                        onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                      }, null, 40, _hoisted_161),
                                                      _cache[111] || (_cache[111] = _createElementVNode("span", { class: "input-suffix" }, "명", -1))
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_162, [
                                                    _cache[114] || (_cache[114] = _createElementVNode("label", { class: "field-label" }, "대표자 월 급여", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['ceoSalary'], expense: true }])
                                                    }, [
                                                      _createElementVNode("input", {
                                                        type: "text",
                                                        class: "main-input",
                                                        placeholder: "0",
                                                        value: formatMultiNumberValue('ceoSalary'),
                                                        onInput: _cache[20] || (_cache[20] = ($event: any) => (handleMultiNumberInput($event, 'ceoSalary'))),
                                                        onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                      }, null, 40, _hoisted_163),
                                                      _cache[113] || (_cache[113] = _createElementVNode("span", { class: "input-suffix" }, "원 / 월", -1))
                                                    ], 2)
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_164, [
                                            _createElementVNode("div", _hoisted_165, [
                                              _createVNode(_component_v_icon, {
                                                size: "16",
                                                color: "#f59e0b"
                                              }, {
                                                default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                                                  _createTextVNode("mdi-account-group", -1)
                                                ]))]),
                                                _: 1
                                              }),
                                              _cache[116] || (_cache[116] = _createElementVNode("span", null, "일반 사회복지사 (모든 보험·퇴직금 적용)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_166, [
                                              _createElementVNode("div", _hoisted_167, [
                                                _cache[118] || (_cache[118] = _createElementVNode("label", { class: "field-label" }, "사회복지사 수", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['workerCount'], expense: true }])
                                                }, [
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "main-input",
                                                    placeholder: "0",
                                                    value: formatMultiNumberValue('workerCount'),
                                                    onInput: _cache[21] || (_cache[21] = ($event: any) => (handleMultiNumberInput($event, 'workerCount'))),
                                                    onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                  }, null, 40, _hoisted_168),
                                                  _cache[117] || (_cache[117] = _createElementVNode("span", { class: "input-suffix" }, "명", -1))
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_169, [
                                                _cache[120] || (_cache[120] = _createElementVNode("label", { class: "field-label" }, "월 급여", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["input-wrapper", { filled: compositeAnswers.value['workerSalary'], expense: true }])
                                                }, [
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "main-input",
                                                    placeholder: "0",
                                                    value: formatMultiNumberValue('workerSalary'),
                                                    onInput: _cache[22] || (_cache[22] = ($event: any) => (handleMultiNumberInput($event, 'workerSalary'))),
                                                    onKeyup: _withKeys(handleEnterKey, ["enter"])
                                                  }, null, 40, _hoisted_170),
                                                  _cache[119] || (_cache[119] = _createElementVNode("span", { class: "input-suffix" }, "원 / 월", -1))
                                                ], 2)
                                              ])
                                            ])
                                          ]),
                                          (socialWorkerBonusPreview.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                                                _createElementVNode("div", _hoisted_172, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "18",
                                                    color: "#6b7280"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                                                      _createTextVNode("mdi-cash-plus", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[122] || (_cache[122] = _createElementVNode("span", null, "가산금수입 (세입 자동 반영)", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_173, [
                                                  _createElementVNode("div", _hoisted_174, [
                                                    _cache[123] || (_cache[123] = _createElementVNode("span", { class: "formula-label" }, "가산점수", -1)),
                                                    _createElementVNode("span", _hoisted_175, _toDisplayString(socialWorkerBonusPreview.value.bonusPoint) + "점", 1),
                                                    _createElementVNode("span", _hoisted_176, "(" + _toDisplayString(socialWorkerBonusPreview.value.count) + "명 기준)", 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_177, [
                                                    _cache[124] || (_cache[124] = _createElementVNode("span", { class: "formula-label" }, "월 가산금", -1)),
                                                    _createElementVNode("span", _hoisted_178, _toDisplayString(formatMoney(socialWorkerBonusPreview.value.monthlyBonus)) + "원", 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_179, [
                                                    _cache[125] || (_cache[125] = _createElementVNode("span", { class: "formula-label" }, "연간 가산금", -1)),
                                                    _createElementVNode("span", _hoisted_180, _toDisplayString(formatMoney(socialWorkerBonusPreview.value.annualBonus)) + "원", 1)
                                                  ])
                                                ]),
                                                _cache[126] || (_cache[126] = _createElementVNode("div", { class: "bonus-detail" }, " (수급자별 청구금액 × 85% ÷ 청구인원수) × 가산점수 × 1.8 ", -1))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (socialWorkerInsurancePreview.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                                                _createElementVNode("div", _hoisted_182, [
                                                  _createVNode(_component_v_icon, {
                                                    size: "18",
                                                    color: "#6b7280"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[127] || (_cache[127] = [
                                                      _createTextVNode("mdi-shield-account", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[128] || (_cache[128] = _createElementVNode("span", null, "사회보험부담금 + 퇴직금 (사업자 부담분)", -1))
                                                ]),
                                                _createElementVNode("div", _hoisted_183, [
                                                  (socialWorkerInsurancePreview.value.ceo)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("div", _hoisted_184, [
                                                          _cache[129] || (_cache[129] = _createElementVNode("span", { class: "summary-label" }, "대표자 연간 급여", -1)),
                                                          _createElementVNode("span", _hoisted_185, _toDisplayString(formatMoney(socialWorkerInsurancePreview.value.ceo.annualSalary)) + "원", 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_186, [
                                                          _cache[130] || (_cache[130] = _createElementVNode("span", { class: "summary-label" }, "대표자 연간 사회보험부담금", -1)),
                                                          _createElementVNode("span", _hoisted_187, _toDisplayString(formatMoney(socialWorkerInsurancePreview.value.ceo.annualInsurance)) + "원", 1)
                                                        ])
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (socialWorkerInsurancePreview.value.worker)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createElementVNode("div", _hoisted_188, [
                                                          _cache[131] || (_cache[131] = _createElementVNode("span", { class: "summary-label" }, "사회복지사 연간 급여", -1)),
                                                          _createElementVNode("span", _hoisted_189, _toDisplayString(formatMoney(socialWorkerInsurancePreview.value.worker.annualSalary)) + "원", 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_190, [
                                                          _cache[132] || (_cache[132] = _createElementVNode("span", { class: "summary-label" }, "사회복지사 연간 사회보험+퇴직금", -1)),
                                                          _createElementVNode("span", _hoisted_191, _toDisplayString(formatMoney(socialWorkerInsurancePreview.value.worker.annualInsurance)) + "원", 1)
                                                        ])
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_192, [
                                                    _cache[133] || (_cache[133] = _createElementVNode("span", { class: "summary-label" }, "총 연간 비용", -1)),
                                                    _createElementVNode("span", _hoisted_193, _toDisplayString(formatMoney(socialWorkerInsurancePreview.value.totalAnnual)) + "원", 1)
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : (currentQuestion.value?.inputType === 'toggle')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                                            _createElementVNode("button", {
                                              class: _normalizeClass(["toggle-option yes", { selected: currentAnswer.value === 'yes' }]),
                                              onClick: _cache[23] || (_cache[23] = ($event: any) => (currentAnswer.value = 'yes'))
                                            }, [
                                              _createElementVNode("div", _hoisted_195, [
                                                _createVNode(_component_v_icon, { size: "28" }, {
                                                  default: _withCtx(() => [...(_cache[134] || (_cache[134] = [
                                                    _createTextVNode("mdi-check-circle", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _cache[135] || (_cache[135] = _createElementVNode("span", { class: "toggle-text" }, "예", -1)),
                                              _cache[136] || (_cache[136] = _createElementVNode("span", { class: "toggle-desc" }, "비용을 책정합니다", -1))
                                            ], 2),
                                            _createElementVNode("button", {
                                              class: _normalizeClass(["toggle-option no", { selected: currentAnswer.value === 'no' }]),
                                              onClick: _cache[24] || (_cache[24] = ($event: any) => (currentAnswer.value = 'no'))
                                            }, [
                                              _createElementVNode("div", _hoisted_196, [
                                                _createVNode(_component_v_icon, { size: "28" }, {
                                                  default: _withCtx(() => [...(_cache[137] || (_cache[137] = [
                                                    _createTextVNode("mdi-close-circle", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _cache[138] || (_cache[138] = _createElementVNode("span", { class: "toggle-text" }, "아니오", -1)),
                                              _cache[139] || (_cache[139] = _createElementVNode("span", { class: "toggle-desc" }, "책정하지 않습니다", -1))
                                            ], 2)
                                          ]))
                                        : _createCommentVNode("", true),
                      (calculatedPreview.value && currentQuestion.value?.inputType === 'number')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 9,
                            class: _normalizeClass(["calc-preview", currentSection.value])
                          }, [
                            _createElementVNode("div", _hoisted_197, [
                              _createVNode(_component_v_icon, { size: "16" }, {
                                default: _withCtx(() => [...(_cache[140] || (_cache[140] = [
                                  _createTextVNode("mdi-calculator", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[141] || (_cache[141] = _createTextVNode(" 자동 계산 결과 ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_198, [
                              _createElementVNode("div", _hoisted_199, [
                                _cache[142] || (_cache[142] = _createElementVNode("span", { class: "preview-label" }, "월 환산", -1)),
                                _createElementVNode("span", _hoisted_200, _toDisplayString(formatMoney(calculatedPreview.value.monthly)) + "원", 1)
                              ]),
                              _createElementVNode("div", _hoisted_201, [
                                _createVNode(_component_v_icon, { size: "20" }, {
                                  default: _withCtx(() => [...(_cache[143] || (_cache[143] = [
                                    _createTextVNode("mdi-arrow-right-bold", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_202, [
                                _cache[144] || (_cache[144] = _createElementVNode("span", { class: "preview-label" }, "연간 합계", -1)),
                                _createElementVNode("span", _hoisted_203, _toDisplayString(formatMoney(calculatedPreview.value.annual)) + "원", 1)
                              ])
                            ])
                          ], 2))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_204, [
                      _createElementVNode("button", {
                        class: "btn-prev",
                        onClick: prevQuestion,
                        disabled: currentStep.value <= 1
                      }, [
                        _createVNode(_component_v_icon, { size: "20" }, {
                          default: _withCtx(() => [...(_cache[145] || (_cache[145] = [
                            _createTextVNode("mdi-arrow-left", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[146] || (_cache[146] = _createTextVNode(" 이전 ", -1))
                      ], 8, _hoisted_205),
                      (currentStep.value < totalQuestions.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass(["btn-next", currentSection.value]),
                            onClick: nextQuestion,
                            disabled: !isCurrentAnswerValid.value
                          }, [
                            _cache[148] || (_cache[148] = _createTextVNode(" 다음 ", -1)),
                            _createVNode(_component_v_icon, { size: "20" }, {
                              default: _withCtx(() => [...(_cache[147] || (_cache[147] = [
                                _createTextVNode("mdi-arrow-right", -1)
                              ]))]),
                              _: 1
                            })
                          ], 10, _hoisted_206))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn-submit",
                            onClick: submitBudget,
                            disabled: !isAllAnswered.value
                          }, [
                            _createVNode(_component_v_icon, { size: "20" }, {
                              default: _withCtx(() => [...(_cache[149] || (_cache[149] = [
                                _createTextVNode("mdi-check-bold", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[150] || (_cache[150] = _createTextVNode(" 예산 생성 완료 ", -1))
                          ], 8, _hoisted_207))
                    ])
                  ], 2))
                ]),
                _: 1
              }),
              (balance.value < 0 && answeredCount.value > 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "#ef4444"
                    }, {
                      default: _withCtx(() => [...(_cache[151] || (_cache[151] = [
                        _createTextVNode("mdi-alert", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("span", null, [
                      _cache[152] || (_cache[152] = _createTextVNode("세출이 세입보다 ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(formatMoney(Math.abs(balance.value))) + "원", 1),
                      _cache[153] || (_cache[153] = _createTextVNode(" 초과합니다", -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ])
  ]))
}
}

})